var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpeakerDistribution = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 773,
  height: 632,
  viewBox: "0 0 773 632",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__loudspeakers-distribution-elements"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-0"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M678.277 175.96L606.486 246.923L554.709 299.76L553.945 298.972C508.57 343.623 447.436 368.68 383.723 368.68C314.566 368.68 252.165 339.753 207.961 293.338L90.2305 175.994L137.436 128.786C147.402 118.82 145.223 110.221 145.135 104.461L177.996 137.322L178.278 137.04V137.322H234.017L298.467 201.77C319.359 225.265 349.813 240.058 383.723 240.058C413.962 240.058 442.964 228.052 464.352 206.679L464.376 206.655L533.72 137.308H593.342V136.768L622.954 107.16C623.087 112.785 622.23 119.918 632.39 130.08C675.844 173.532 678.184 175.866 678.277 175.96Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 1.3,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-0"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_2",
  d: "M264.736 228.596L198.06 161.92L192.529 167.451L259.205 234.127L264.736 228.596Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.472022,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_3",
  d: "M504.761 228.596L597.319 136.037L602.85 141.568L510.292 234.127L504.761 228.596Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.412421,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_4",
  d: "M290.646 201.558L231.012 141.924L225.481 147.455L285.115 207.089L290.646 201.558Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.494051,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_5",
  d: "M478.846 201.558L538.479 141.924L544.01 147.455L484.376 207.089L478.846 201.558Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.494051,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_6",
  d: "M255.571 237.76L188.896 171.084L183.365 176.615L250.04 243.291L255.571 237.76Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.472022,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_7",
  d: "M513.921 237.762L618.409 133.273L623.94 138.804L519.452 243.292L513.921 237.762Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.391718,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_8",
  d: "M281.48 210.72L215.162 144.402L209.631 149.933L275.949 216.251L281.48 210.72Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.473399,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_8"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_9",
  d: "M488.012 210.72L554.33 144.402L559.861 149.933L493.543 216.251L488.012 210.72Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.473399,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_9"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_10",
  d: "M246.409 246.924L141.053 141.568L135.522 147.099L240.878 252.455L246.409 246.924Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_10"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_11",
  d: "M523.082 246.928L628.438 141.572L633.968 147.103L528.612 252.459L523.082 246.928Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_11"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_12",
  d: "M237.245 256.088L131.889 150.732L126.358 156.263L231.714 261.619L237.245 256.088Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_12"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_13",
  d: "M532.248 256.088L637.604 150.732L643.134 156.263L537.778 261.619L532.248 256.088Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_13"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_14",
  d: "M228.082 265.252L122.726 159.896L117.195 165.427L222.551 270.783L228.082 265.252Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_14"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_15",
  d: "M541.412 265.252L646.768 159.896L652.298 165.427L546.942 270.783L541.412 265.252Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_15"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_16",
  d: "M218.917 274.417L113.561 169.061L108.03 174.591L213.386 279.947L218.917 274.417Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_16"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_17",
  d: "M550.577 274.417L655.933 169.061L661.463 174.591L556.107 279.947L550.577 274.417Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_17"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_18",
  d: "M209.754 283.581L104.398 178.225L98.8671 183.755L204.223 289.111L209.754 283.581Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_18"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_19",
  d: "M559.741 283.581L665.097 178.225L670.628 183.755L565.272 289.111L559.741 283.581Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.390008,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_19"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_20",
  d: "M114.334 369.573L97.4214 352.66L91.9912 358.09L108.904 375.003L114.334 369.573Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.588895,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_20"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_21",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M334.733 363.265L336.462 355.387C292.838 345.835 252.691 324.439 220.429 293.574L214.842 299.406C248.183 331.294 289.664 353.395 334.733 363.265Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.613621,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_21"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_22",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M434.761 363.265L433.032 355.387C476.657 345.835 516.803 324.439 549.065 293.574L554.652 299.406C521.311 331.294 479.83 353.395 434.761 363.265Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.613621,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_22"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_23",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M413.011 366.978L411.925 357.537C402.529 358.635 393.087 359.178 383.646 359.178C374.194 359.178 364.753 358.635 355.369 357.537L354.271 366.978C364.018 368.11 373.821 368.676 383.646 368.676C393.461 368.676 403.264 368.11 413.011 366.978Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.621741,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_23"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_24",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.478 349.933L339.182 342.179C297.759 333.099 259.631 312.79 228.988 283.477L223.491 289.218C255.191 319.536 294.628 340.549 337.478 349.933Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.583403,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_24"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_25",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.013 349.933L430.309 342.179C471.732 333.099 509.861 312.79 540.503 283.477L546 289.218C514.301 319.536 474.863 340.549 432.013 349.933Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.583403,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_25"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_26",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.01 352.65L410.059 344.375C401.294 345.379 392.464 345.891 383.645 345.891C374.816 345.891 365.987 345.379 357.221 344.375L356.271 352.65C365.357 353.696 374.495 354.219 383.645 354.219C392.784 354.219 401.924 353.696 411.01 352.65Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.586392,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_26"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_27",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.285 337.425L342.031 329.481C303.005 320.935 267.081 301.8 238.219 274.179L232.591 280.063C262.54 308.707 299.801 328.56 340.285 337.425Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.64306,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_27"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_28",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M429.207 337.425L427.461 329.481C466.487 320.935 502.411 301.8 531.274 274.179L536.901 280.063C506.952 308.707 469.691 328.56 429.207 337.425Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.64306,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_28"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_29",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M409.387 340.369L408.424 331.904C400.213 332.836 391.95 333.302 383.688 333.302C375.415 333.302 367.153 332.836 358.941 331.904L357.978 340.369C366.514 341.341 375.091 341.827 383.688 341.827C392.274 341.827 400.851 341.341 409.387 340.369Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.556136,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_29"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_30",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M343.031 324.659L344.71 316.993C307.968 308.95 274.151 290.928 246.969 264.926L241.539 270.6C269.764 297.595 304.878 316.304 343.031 324.659Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.606026,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_30"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_31",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M426.462 324.659L424.783 316.993C461.524 308.95 495.342 290.928 522.523 264.926L527.953 270.6C499.729 297.595 464.614 316.304 426.462 324.659Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.606026,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_31"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_32",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.48 328.009L406.6 320.113C398.972 320.965 391.306 321.395 383.64 321.395C375.964 321.395 368.298 320.965 360.67 320.113L359.79 328.009C367.714 328.889 375.667 329.329 383.64 329.329C391.602 329.329 399.566 328.889 407.48 328.009Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.613263,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_32"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_33",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M345.859 311.784L347.505 304.298C313.069 296.751 281.385 279.875 255.919 255.51L250.613 261.051C277.101 286.385 310.055 303.943 345.859 311.784Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.568733,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_33"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_34",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M423.633 311.784L421.987 304.298C456.423 296.751 488.107 279.875 513.573 255.51L518.879 261.051C492.391 286.385 459.437 303.943 423.633 311.784Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.568733,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_34"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_35",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M405.614 314.562L404.825 307.307C397.803 308.069 390.736 308.454 383.678 308.454C376.612 308.454 369.545 308.069 362.523 307.307L361.734 314.562C369.016 315.36 376.343 315.763 383.678 315.763C391.005 315.763 398.332 315.36 405.614 314.562Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.574638,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_35"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_36",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M348.545 299.152L350.078 292.149C317.836 285.09 288.155 269.276 264.305 246.457L259.345 251.639C284.151 275.365 315.013 291.808 348.545 299.152Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.608727,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_36"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_37",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M420.948 299.152L419.415 292.149C451.657 285.09 481.339 269.276 505.188 246.457L510.149 251.639C485.342 275.365 454.48 291.808 420.948 299.152Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.608727,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_37"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_38",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M403.898 302.138L403.091 294.629C396.616 295.327 390.115 295.68 383.615 295.68C377.106 295.68 370.606 295.327 364.139 294.629L363.324 302.138C370.059 302.87 376.837 303.231 383.615 303.231C390.384 303.231 397.163 302.87 403.898 302.138Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.615823,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_38"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_39",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M351.39 286.858L353.04 279.336C323.318 272.824 295.963 258.254 273.985 237.224L268.655 242.789C291.663 264.795 320.288 280.047 351.39 286.858Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.635182,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_39"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_40",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M418.102 286.858L416.453 279.336C446.174 272.824 473.529 258.254 495.507 237.224L500.838 242.789C477.829 264.795 449.204 280.047 418.102 286.858Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.635182,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_40"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_41",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.103 265.077L376.636 257.363C345.408 255.201 315.773 242.769 292.357 221.997L287.224 227.784C311.925 249.688 343.175 262.796 376.103 265.077Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.608645,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_41"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_42",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M393.391 265.077L392.858 257.363C424.086 255.201 453.721 242.769 477.137 221.997L482.27 227.784C457.569 249.688 426.319 262.796 393.391 265.077Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.608645,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_42"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_43",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.818 252.378L377.34 245.267C348.756 243.165 321.657 231.726 300.216 212.707L295.485 218.042C318.097 238.098 346.678 250.16 376.818 252.378Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.617191,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_43"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_44",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M392.676 252.378L392.154 245.267C420.738 243.165 447.837 231.726 469.278 212.707L474.01 218.042C451.397 238.098 422.816 250.16 392.676 252.378Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.617191,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_44"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_45",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M402.109 289.561L401.253 281.488C395.391 282.111 389.505 282.422 383.619 282.422C377.726 282.422 371.84 282.111 365.978 281.488L365.122 289.561C371.264 290.215 377.438 290.542 383.619 290.542C389.793 290.542 395.967 290.215 402.109 289.561Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.570123,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_46",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M192.968 313.393L72.5264 194.472L90.27 176.008L213.013 297.905L212.83 298.111L213.093 297.911C258.655 340.879 318.585 368.413 383.791 368.413C448.996 368.413 511.757 340.992 557.637 296.404L678.281 176.191L690.231 188.227L696.459 194.337L571.558 316.942L571.385 316.694C521.098 365.291 453.847 392.523 383.791 392.523C312.191 392.523 243.524 364.081 192.896 313.453L192.968 313.393Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.60329,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_45"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_47",
  d: "M190.848 300.496L86.457 196.105L81.0269 201.536L185.418 305.927L190.848 300.496Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.387956,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_46"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_48",
  d: "M578.155 300.006L682.546 195.615L687.976 201.045L583.585 305.436L578.155 300.006Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.387956,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_47"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_49",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M253.209 358.559L256.792 352.076C236.637 340.92 218.027 327.152 201.467 311.143L196.314 316.463C213.342 332.939 232.479 347.091 253.209 358.559Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.548451,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_48"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_50",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M514.659 359.051L511.076 352.568C531.231 341.412 549.841 327.644 566.401 311.635L571.554 316.955C554.526 333.431 535.39 347.583 514.659 359.051Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.548451,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_49"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_51",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M419.489 389.828L418.5 382.482C395.458 385.58 372.108 385.597 349.074 382.535L348.092 389.876C371.789 393.029 395.799 393.016 419.489 389.828Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.548452,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_50"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_52",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M334.293 387.658L335.648 380.372C312.791 376.119 290.603 368.844 269.677 358.742L266.452 365.409C287.979 375.805 310.793 383.29 334.293 387.658Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.548453,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_51"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_53",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M434.559 387.658L433.204 380.372C456.061 376.119 478.249 368.844 499.175 358.742L502.4 365.409C480.872 375.805 458.059 383.29 434.559 387.658Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.548453,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group 255"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2a"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_54",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M183.941 322.415L115.885 254.385L124.592 245.717L196.308 316.469L196.198 316.587C246.482 365.209 313.738 392.45 383.802 392.45C455.382 392.45 524.033 364.017 574.648 313.403L574.659 313.414L642.638 246.411L651.685 255.289L584.112 322.426C531.103 375.436 458.77 405.218 383.802 405.218C310.525 405.218 240.181 376.763 187.542 325.979L187.522 325.995L186.049 324.527C185.34 323.833 184.633 323.132 183.93 322.426L183.941 322.415Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2c"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_55",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M178.674 334.586L178.524 334.931L111.509 267.821L114.708 255.556L115.885 254.387L183.952 322.428L183.945 322.445C236.953 375.443 308.843 405.22 383.802 405.22C458.358 405.22 530.098 375.979 583.022 323.512L582.994 323.507L651.482 255.245L652.888 256.544L656.389 270.566L602.279 324.128L598.62 327.714C597.744 328.595 589.951 335.817 589.059 336.676C534.921 388.318 460.803 417.57 383.802 417.57C307.188 417.57 233.645 387.77 178.674 334.586Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2d"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_56",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M169.455 343.824L169.295 344.157L107.679 282.497L111.509 267.82L175.196 331.683C230.566 386.917 305.585 418.292 383.802 417.936C475.372 417.53 546.192 379.881 602.279 324.127L656.146 269.017L660.167 284.434L602.792 342.04L602.781 341.565C545.012 399.329 465.501 430.62 383.802 430.62C303.73 430.62 226.873 399.448 169.455 343.824Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2e"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_57",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.357 355.117L162.139 355.4L99.6235 293.158L106.814 285.811L107.679 282.496L169.058 343.919L169.295 343.665C224.69 399.063 305.461 430.743 383.802 430.743C462.135 430.743 543.323 400.909 598.715 345.523L598.619 345.421L660.166 284.433L660.364 285.811L668.631 294.253L608.411 355.174L608.445 355.202C550.67 412.977 465.659 443.42 383.957 443.42C303.189 443.42 220.061 411.656 162.357 355.117Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2f"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_58",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M151.67 362.86L151.432 363.114L107.072 319.067L113.125 313.217L96.5127 296.338L99.6236 293.158L160.124 353.395L160.363 353.141C215.758 408.539 294.547 443.545 383.802 443.545C480.963 443.545 557.791 404.75 607.988 355.598L668.632 294.254L670.67 296.338L654.26 313.838L660.771 320.225L616.424 364.317L616.182 364.068C558.423 421.697 476.586 456.223 383.957 456.223C291.325 456.223 209.431 420.494 151.67 362.86Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2g"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_59",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.77 372.068L142.531 372.322L103.313 333.239L106.322 319.793L107.123 319.02L151.223 362.604L151.463 362.349C206.858 417.747 289.544 456.605 383.803 456.599C483.047 456.593 564.241 417.041 616.425 363.829L616.662 364.089L660.771 320.228L664.702 334.498L625.494 374.197L625.257 373.937C567.493 431.577 483.267 469.277 383.958 469.277C284.651 469.277 200.536 429.713 142.77 372.068Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2h"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_60",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.606 380.096L133.324 381.395L100.127 347.467L103.313 333.236L141.944 371.778L142.256 371.422C208.666 436.086 289.837 468.348 383.803 469.398C481.562 470.494 570.26 430.643 625.494 373.698L625.737 373.946L664.323 334.874L668.056 349.342L634.4 383.394L634.157 383.145C576.365 440.796 483.262 483.064 383.958 483.064C284.514 483.064 191.248 439.153 133.475 381.378L134.606 380.096Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2i"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_61",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.978 431.32L91.8599 432.466L73.0625 413.814L108.812 377.701L89.0267 358.247L100.127 347.467L133.323 381.394C204.486 448.809 289.837 482.014 383.802 483.064C481.562 484.16 578.313 437.464 636.393 381.394L668.395 349.353L678.689 359.156L658.783 378.689L693.744 414.001L675.103 432.664L675.324 432.958C612.658 491.196 516.472 545.634 383.958 545.634C270.903 545.634 169.5 506.375 91.6571 432.958L92.978 431.32ZM203.516 450.69C180.685 437.679 153.813 418.055 128.302 395.247L95.0691 429.75C120.095 453.592 148.776 474.582 181.311 492.608L203.516 450.69ZM313.927 491.789C285.444 486.876 249.358 473.837 224.6 461.34L203.534 504.365C234.886 519.109 267.963 530.579 304.912 537.705L313.927 491.789ZM564.088 451.593L585.784 492.608C618.322 474.582 646.998 453.592 672.026 429.75L639.888 396.353C614.375 419.162 586.919 438.582 564.088 451.593ZM431.608 498.164C404.671 502.236 361.002 502.801 336.67 498.164L330.735 538.863C370.461 543.217 394.343 544.115 437.594 540.224L431.608 498.164ZM453.789 491.693L462.181 537.705C499.135 530.579 532.21 519.109 563.563 504.365L542.499 461.34C527.325 470.793 487.429 485.289 453.789 491.693Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.599635,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_52"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_53"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_62",
  d: "M181.746 309.594L122.455 250.303L117.025 255.733L176.316 315.024L181.746 309.594Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.490602,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_54"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_63",
  d: "M586.759 309.1L646.051 249.809L651.481 255.239L592.19 314.53L586.759 309.1Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.490602,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_55"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_64",
  d: "M172.647 318.692L117.829 263.875L112.399 269.305L167.216 324.123L172.647 318.692Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.505084,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_56"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_65",
  d: "M596.848 318.692L651.665 263.875L657.095 269.305L602.278 324.123L596.848 318.692Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.505084,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_57"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_66",
  d: "M163.548 327.793L114.278 278.523L108.848 283.954L158.118 333.223L163.548 327.793Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.524018,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_58"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_67",
  d: "M605.946 327.793L655.216 278.523L660.646 283.954L611.376 333.223L605.946 327.793Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.524018,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_59"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_68",
  d: "M154.447 336.892L105.795 288.24L100.365 293.67L149.017 342.323L154.447 336.892Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.525213,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_60"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_69",
  d: "M615.047 336.893L662.379 289.561L667.81 294.991L620.477 342.323L615.047 336.893Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.531322,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_61"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_70",
  d: "M145.348 345.994L114.153 314.799L108.723 320.229L139.918 351.424L145.348 345.994Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585908,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_62"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_71",
  d: "M624.145 345.994L655.34 314.799L660.77 320.229L629.575 351.424L624.145 345.994Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585908,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_63"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_72",
  d: "M136.248 355.091L109.336 328.18L103.906 333.61L130.818 360.522L136.248 355.091Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.597616,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_64"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_73",
  d: "M633.245 355.091L660.156 328.18L665.586 333.61L638.675 360.522L633.245 355.091Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.597616,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_65"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_74",
  d: "M127.149 364.19L106.183 343.225L100.753 348.655L121.719 369.621L127.149 364.19Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.599679,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_66"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_75",
  d: "M642.343 364.19L663.309 343.225L668.739 348.655L647.773 369.621L642.343 364.19Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.599679,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_67"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_68"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_76",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M332.013 400.514L333.381 393.117C309.366 388.662 286.055 381.01 264.056 370.399L260.787 377.168C283.389 388.082 307.335 395.934 332.013 400.514Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.575019,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_69"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_77",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M436.869 400.512L435.501 393.115C459.25 388.705 482.323 381.174 504.12 370.734L507.37 377.521C484.985 388.257 461.281 395.977 436.869 400.512Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.575019,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_70"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_78",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M329.877 413.119L331.261 405.665C306.061 401.012 281.606 393.001 258.539 381.862L255.243 388.676C278.92 400.111 304.026 408.336 329.877 413.119Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.601086,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_71"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_79",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M439.007 413.119L437.623 405.665C462.823 401.012 487.278 393.001 510.345 381.862L513.641 388.676C489.964 400.111 464.858 408.336 439.007 413.119Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.601086,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_72"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_80",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.504 425.938L328.913 418.354C302.591 413.469 277.03 405.112 252.926 393.473L249.571 400.415C274.294 412.355 300.51 420.943 327.504 425.938Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.627657,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_73"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_81",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M441.379 425.938L439.969 418.354C466.291 413.469 491.853 405.112 515.957 393.473L519.312 400.415C494.589 412.355 468.373 420.943 441.379 425.938Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.627657,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_74"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_82",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.151 438.554L326.565 430.943C299.123 425.864 272.481 417.152 247.34 405.011L243.981 411.971C269.732 424.407 297.036 433.352 325.151 438.554Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.653726,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_75"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_83",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M443.732 438.554L442.319 430.943C469.761 425.864 496.403 417.152 521.544 405.011L524.842 412.973C499.078 425.405 471.848 433.352 443.732 438.554Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.653726,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_76"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_84",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M322.839 451.122L324.218 443.692C295.644 438.391 267.889 429.317 241.722 416.669L238.433 423.479C265.21 436.411 293.603 445.712 322.839 451.122Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.543835,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_77"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_85",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M446.044 451.122L444.666 443.692C473.24 438.391 500.995 429.317 527.162 416.669L530.698 424.342C503.921 437.274 475.281 445.712 446.044 451.122Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.543835,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_78"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_86",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M320.467 463.988L321.865 456.457C292.145 450.959 263.3 441.515 236.095 428.377L232.761 435.264C260.585 448.702 290.088 458.367 320.467 463.988Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565091,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_79"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_87",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.416 463.988L447.018 456.457C476.738 450.959 505.583 441.515 532.787 428.377L536.544 436.297C508.706 449.73 478.795 458.367 448.416 463.988Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565091,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_80"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_88",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M318.114 476.558L319.492 469.142C288.639 463.436 258.689 453.624 230.445 439.996L227.171 446.773C256.022 460.707 286.614 470.728 318.114 476.558Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585947,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_81"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_89",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M450.77 476.558L449.392 469.142C480.244 463.436 510.195 453.624 538.439 439.996L541.713 446.773C512.862 460.707 482.27 470.728 450.77 476.558Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585947,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_82"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_90",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.295 402.752L420.284 395.298C396.078 398.565 371.544 398.575 347.332 395.364L346.339 402.815C371.219 406.126 396.42 406.107 421.295 402.752Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.575019,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_83"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_91",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M423.191 415.385L422.177 407.871C396.785 411.32 371.051 411.346 345.66 407.968L344.656 415.47C370.719 418.94 397.138 418.913 423.191 415.385Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.601087,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_84"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_92",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M424.93 428.318L423.9 420.672C397.369 424.251 370.476 424.295 343.943 420.764L342.924 428.407C370.139 432.029 397.726 432.002 424.93 428.318Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.627657,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_85"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_93",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M426.653 441.018L425.62 433.346C397.964 437.091 369.934 437.133 342.258 433.45L341.241 441.11C369.587 444.884 398.319 444.855 426.653 441.018Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.653725,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_86"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_94",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M428.376 453.665L427.365 446.176C398.565 450.063 369.364 450.11 340.556 446.265L339.558 453.762C369.034 457.685 398.912 457.655 428.376 453.665Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.543835,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_87"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_95",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M430.162 466.645L429.138 459.054C399.187 463.112 368.836 463.148 338.889 459.162L337.872 466.745C368.5 470.823 399.547 470.791 430.162 466.645Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565092,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_88"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_96",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M431.835 479.343L430.829 471.869C399.737 476.082 368.221 476.113 337.133 471.987L336.14 479.447C367.898 483.675 400.09 483.642 431.835 479.343Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585948,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_89"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_97",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M247.585 370.302L251.203 363.706C229.795 351.947 210.059 337.373 192.495 320.4L187.269 325.803C205.31 343.253 225.587 358.216 247.585 370.302Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.575017,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_90"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_98",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M519.563 370.427L515.933 363.832C537.428 352.048 557.254 337.436 574.88 320.4L580.106 325.803C562.003 343.316 541.637 358.329 519.563 370.427Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.575017,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_91"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_99",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M241.55 381.628L245.201 374.983C222.731 362.664 202.02 347.39 183.608 329.582L178.342 335.019C197.24 353.3 218.502 368.981 241.55 381.628Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.601086,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_92"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_100",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M525.827 381.627L522.176 374.982C544.646 362.664 566.132 348.283 584.544 330.475L589.81 335.912C570.911 354.193 548.875 368.98 525.827 381.627Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.601086,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_93"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_101",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M235.3 393.074L239.017 386.314C215.553 373.423 193.9 357.474 174.66 338.865L169.298 344.405C189.031 363.494 211.233 379.868 235.3 393.074Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.627656,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_94"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_102",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M532.618 394.059L528.901 387.298C552.365 374.408 574.018 358.459 593.258 339.85L598.62 345.39C578.886 364.479 556.685 380.853 532.618 394.059Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.627656,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_95"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_103",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M229.113 404.313L232.842 397.529C208.375 384.103 185.808 367.477 165.74 348.066L160.369 353.622C180.923 373.504 204.047 390.558 229.113 404.313Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.653726,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_96"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_104",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M538.755 406.281L535.026 399.497C559.493 386.071 582.06 369.446 602.128 350.035L607.499 355.591C586.946 375.473 563.822 392.527 538.755 406.281Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.653726,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_97"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_105",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.928 415.55L226.566 408.926C201.094 394.935 177.583 377.617 156.7 357.402L151.442 362.838C172.815 383.513 196.861 401.247 222.928 415.55Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.543836,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_98"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_106",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M544.941 417.026L541.302 410.402C566.774 396.411 590.285 379.093 611.168 358.879L616.426 364.314C595.053 384.989 571.007 402.723 544.941 417.026Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.543836,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_99"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_107",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M216.678 426.997L220.367 420.284C193.869 405.746 169.438 387.735 147.724 366.73L142.399 372.225C164.607 393.708 189.593 412.135 216.678 426.997Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565092,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_100"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_108",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M551.239 428.97L547.55 422.256C574.048 407.718 598.479 389.708 620.193 368.703L625.518 374.198C603.31 395.68 578.324 414.108 551.239 428.97Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565092,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_101"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_109",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M210.539 438.187L214.173 431.577C186.664 416.487 161.3 397.78 138.752 375.984L133.519 381.393C156.547 403.669 182.455 422.776 210.539 438.187Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585946,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_102"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_110",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M556.914 439.325L553.28 432.716C580.789 417.626 606.569 399.751 629.117 377.955L634.35 383.364C611.322 405.64 584.998 423.915 556.914 439.325Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585946,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-2j"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Floor-2J"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_111",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M203.557 450.689L181.352 492.607C148.818 474.583 120.136 453.59 95.1111 429.748L128.343 395.246C153.854 418.057 180.726 437.678 203.557 450.689Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.337275,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Floor-2J1"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_112",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M564.127 451.588L585.826 492.604C618.36 474.58 647.042 453.587 672.067 429.745L639.928 396.348C614.416 419.158 586.959 438.577 564.127 451.588Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.337275,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Floor-2J2"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_113",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.345 490.217L304.95 537.701C268.001 530.579 234.923 519.108 203.571 504.367L224.637 461.34C246.749 471.994 284.047 484.644 313.345 490.217Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.337275,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Floor-2J3"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_114",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M431.649 498.162L437.631 541.696C394.384 545.586 370.502 544.691 330.776 540.337L336.711 498.162C361.043 502.798 404.712 502.228 431.649 498.162Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.337275,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Floor-2J4"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_115",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M453.832 490.217L462.227 537.701C499.176 530.579 532.254 519.108 563.606 504.367L542.54 461.34C527.369 470.795 487.47 483.812 453.832 490.217Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.337275,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-2i"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_103"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_116",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M185.687 439.308L189.838 432.665C170.161 420.361 151.714 406.213 134.711 390.422L129.38 396.151C146.748 412.291 165.595 426.738 185.687 439.308Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.608004,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_104"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_117",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M637.847 398.394L632.549 392.648C615.496 408.39 596.982 422.471 577.271 434.692L581.389 441.335C601.531 428.848 620.428 414.468 637.847 398.394Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.608004,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_105"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_118",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M428.989 493.645L428.02 485.451C413.282 487.219 398.458 488.103 383.635 488.103C368.795 488.103 353.973 487.219 339.235 485.451L338.265 493.645C353.309 495.446 368.472 496.347 383.635 496.347C398.798 496.347 413.945 495.446 428.989 493.645Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.622422,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_106"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_119",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M241.1 468.693L244.177 461.043C265.918 469.78 288.424 476.478 311.406 481.016L309.809 489.108C286.316 484.467 263.317 477.634 241.1 468.693Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.622422,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_107"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_120",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M527.752 468.693L524.675 461.043C502.933 469.78 480.427 476.478 457.445 481.016L459.043 489.108C482.535 484.467 505.535 477.634 527.752 468.693Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.622422,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-2j"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_108"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_121",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M178.761 455.371L183.052 448.405C162.536 435.758 143.253 421.219 125.465 404.941L119.941 410.986C138.111 427.594 157.793 442.464 178.761 455.371Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.63608,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_109"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_122",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M588.171 455.371L583.88 448.405C604.396 435.758 623.679 421.219 641.467 404.941L646.992 410.986C628.821 427.594 609.139 442.464 588.171 455.371Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.63608,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_110"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_123",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M306.619 505.714L308.233 497.688C284.59 492.946 261.469 485.98 239.146 476.877L236.071 484.451C258.863 493.745 282.472 500.867 306.619 505.714Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.63608,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_111"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_124",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M460.314 505.714L458.699 497.688C482.342 492.946 505.464 485.98 527.787 476.877L530.862 484.451C508.07 493.745 484.461 500.867 460.314 505.714Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.63608,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_112"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_125",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.984 467.132L178 460.532C156.125 447.21 135.594 431.808 116.696 414.523L111.478 420.225C130.753 437.851 151.678 453.558 173.984 467.132Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.656533,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_113"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_126",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M592.95 467.132L588.934 460.532C610.809 447.21 631.339 431.808 650.238 414.523L655.456 420.225C636.181 437.851 615.255 453.558 592.95 467.132Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.656533,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_114"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_127",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M304.516 518.073L306.023 510.506C280.921 505.486 256.356 498.026 232.67 488.254L229.729 495.39C253.864 505.36 278.912 512.962 304.516 518.073Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.656533,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_115"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_128",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M462.413 518.073L460.906 510.506C486.009 505.486 510.574 498.026 534.26 488.254L537.2 495.39C513.066 505.36 488.018 512.962 462.413 518.073Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.656533,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_116"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_129",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M180.742 485.018L184.398 478.499C157.049 463.171 131.563 444.759 108.443 423.596L103.383 429.118C126.928 450.669 152.894 469.413 180.742 485.018Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.676184,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_117"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_130",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.238 485.018L582.582 478.499C609.932 463.171 635.417 444.759 658.538 423.596L663.598 429.118C640.052 450.669 614.087 469.413 586.238 485.018Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.676184,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_118"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_131",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M302.347 529.93L303.807 522.599C273.558 516.56 244.083 507.105 215.976 494.418L212.893 501.233C241.535 514.16 271.544 523.78 302.347 529.93Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.676184,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_119"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_132",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.632 529.93L463.173 522.599C493.422 516.56 522.896 507.105 551.003 494.418L554.087 501.233C525.445 514.16 495.436 523.78 464.632 529.93Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.676184,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_133",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M383.591 573.053C259.457 570.617 149.497 526.017 56.1895 431.87L58.5923 410.959L70.2689 399.431L55.3089 383.711L58.5923 355.528L69.7762 344.935L54.8163 329.609L58.5923 301.815L69.7762 289.342L55.3089 275.41L59.918 245.812L70.761 235.127L52.1201 216.041L72.5264 194.471L125.022 245.812L114.709 255.558L106.815 285.809L96.5132 296.338L113.126 313.219L106.322 319.794L100.127 347.468L89.027 358.245L108.813 377.704L75.8876 410.959C160.706 500.892 275.866 545.649 383.591 543.979V542.677C457.315 542.677 506.766 531.274 563.59 504.631C628.799 474.06 669.768 432.513 691.344 410.959L658.37 377.704L678.157 358.245L667.056 347.468L660.86 319.794L654.059 313.219L670.67 296.338L660.368 285.809L652.476 255.558L642.795 246.563L695.919 193.807L716.825 214.502L696.422 235.127L707.264 245.812L711.872 275.41L697.405 289.342L708.593 301.815L712.369 329.609L697.405 344.935L708.593 355.528L711.872 383.711L696.913 399.431L708.593 410.959L710.991 431.87C617.687 526.017 507.728 570.617 383.591 573.053Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.667575,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_120"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_121"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_134",
  d: "M115.828 248.28L83.751 216.203L78.3208 221.633L110.398 253.71L115.828 248.28Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.583198,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_122"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_135",
  d: "M109.777 260.911L76.1899 227.324L70.7598 232.754L104.347 266.342L109.777 260.911Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.579984,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_123"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_136",
  d: "M106.814 275.391L66.3799 234.957L60.9497 240.387L101.384 280.821L106.814 275.391Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.554514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_124"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_137",
  d: "M100.504 287.177L60.9497 247.623L55.5195 253.053L95.0734 292.607L100.504 287.177Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.558563,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_125"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_138",
  d: "M106.814 311.63L54.3638 259.18L48.9336 264.61L101.384 317.06L106.814 311.63Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.512701,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_126"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_139",
  d: "M100.503 323.036L55.5723 278.105L50.1421 283.536L95.073 328.466L100.503 323.036Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.539239,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_127"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_140",
  d: "M100.165 379.441L53.3179 332.594L47.8877 338.024L94.7346 384.871L100.165 379.441Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.532997,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_128"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_141",
  d: "M98.3243 339.504L54.1157 295.295L48.6856 300.725L92.8941 344.934L98.3243 339.504Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.541306,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_129"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_142",
  d: "M91.0178 388.94L53.3145 351.236L47.8843 356.666L85.5877 394.37L91.0178 388.94Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565099,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_130"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_143",
  d: "M92.6626 351.152L52.001 310.49L46.5708 315.92L87.2325 356.582L92.6626 351.152Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.554019,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_131"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_144",
  d: "M80.8224 396.052L53.0571 368.287L47.627 373.717L75.3922 401.483L80.8224 396.052Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.59515,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_132"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_133"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_145",
  d: "M652.622 249.324L684.364 217.582L689.794 223.012L658.052 254.754L652.622 249.324Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.58558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_134"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_146",
  d: "M658.467 261.755L690.349 229.873L695.779 235.303L663.897 267.185L658.467 261.755Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.585057,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_135"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_147",
  d: "M661.851 276.649L699.762 238.738L705.192 244.168L667.281 282.08L661.851 276.649Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.564673,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_136"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_148",
  d: "M668.248 288.527L705.9 250.875L711.331 256.305L673.679 293.957L668.248 288.527Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.564714,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_137"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_149",
  d: "M662.007 313.045L713.261 261.791L718.691 267.221L667.437 318.475L662.007 313.045Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.51834,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_138"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_150",
  d: "M668.6 324.734L713.531 279.803L718.961 285.233L674.03 330.164L668.6 324.734Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.539239,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_139"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_151",
  d: "M666.252 381.917L713.265 334.904L718.695 340.334L671.682 387.348L666.252 381.917Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.531735,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_140"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_152",
  d: "M670.593 341.017L714.801 296.809L720.231 302.239L676.023 346.447L670.593 341.017Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.541306,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_141"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_153",
  d: "M675.758 390.684L713.262 353.18L718.692 358.61L681.189 396.114L675.758 390.684Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.565573,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_142"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_154",
  d: "M655.16 369.575L672.073 352.662L677.503 358.092L660.59 375.005L655.16 369.575Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.588895,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_143"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_155",
  d: "M676.74 353.15L713.013 316.877L718.443 322.307L682.17 358.58L676.74 353.15Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.569781,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_144"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_156",
  d: "M686.258 398.462L713.261 371.459L718.691 376.889L691.689 403.892L686.258 398.462Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.596955,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_145"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_146"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_157",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M180.282 505.519L183.944 498.617C134.054 472.11 89.9474 435.946 54.1874 392.205L48.1337 397.159C84.5492 441.69 129.485 478.53 180.282 505.519Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.529397,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_147"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_158",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.701 505.519L583.038 498.617C632.929 472.11 677.035 435.946 712.795 392.205L718.849 397.159C682.433 441.69 637.497 478.53 586.701 505.519Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.529397,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_148"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_159",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M307.379 549.416L308.747 541.724C269.999 534.803 232.408 522.543 197.034 505.289L193.621 512.306C229.632 529.868 267.917 542.36 307.379 549.416Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.529397,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_149"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_160",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M459.603 549.416L458.234 541.724C496.982 534.803 534.573 522.543 569.948 505.289L573.36 512.306C537.349 529.868 499.064 542.36 459.603 549.416Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.529397,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_150"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_161",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M441.993 552.213L440.953 544.463C421.945 547.065 402.783 548.357 383.601 548.357C364.401 548.357 345.24 547.065 326.232 544.463L325.191 552.213C344.545 554.835 364.054 556.164 383.601 556.164C403.13 556.164 422.638 554.835 441.993 552.213Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.529397,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_151"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_162",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M174.512 516.422L178.279 509.324C130.976 484.185 88.6894 450.601 53.5193 410.197L47.4727 415.471C83.2772 456.608 126.337 490.827 174.512 516.422Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.544437,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_152"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_163",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M592.469 516.422L588.702 509.324C636.005 484.185 678.292 450.601 713.462 410.197L719.508 415.471C683.704 456.608 640.644 490.827 592.469 516.422Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.544437,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_153"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_164",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.234 562.081L309.603 554.171C268.703 547.153 229.032 534.365 191.741 516.186L188.232 523.402C226.197 541.919 266.601 554.944 308.234 562.081Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.544437,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_154"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_165",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.747 562.081L457.379 554.171C498.278 547.153 537.949 534.365 575.24 516.186L578.75 523.402C540.784 541.919 500.381 554.944 458.747 562.081Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.544437,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_155"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_166",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M444.316 564.339L443.226 556.389C423.46 559.105 403.555 560.473 383.611 560.473C363.667 560.473 343.743 559.105 323.977 556.389L322.886 564.339C343.009 567.114 363.29 568.501 383.611 568.501C403.912 568.501 424.194 567.114 444.316 564.339Z",
  fill: "#F6F9FF",
  stroke: "#281E64",
  strokeWidth: 0.544437,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__floor-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_167",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M382.823 573.111C523.964 570.458 635.981 509.777 710.227 431.436L707.823 410.525L701.578 404.339L696.144 398.997L711.107 383.277L707.823 355.094L696.635 344.501L711.599 329.175L707.823 301.381L696.635 288.908L711.107 274.971L706.499 245.378L695.652 234.688L716.277 214.068L695.911 193.897L677.733 175.756L716.904 133.262V32.384H734.871V494.889C610.958 599.397 495.133 629.865 382.823 630.967V630.999C270.515 629.897 154.907 599.397 30.9939 494.889L31.4866 129.626H13.9277L13.4351 31.9395L48.965 32.384V130.799L89.7219 175.573L51.1901 215.667L70.2129 234.688L59.3699 245.378L54.7609 274.971L69.2281 288.908L58.0442 301.381L54.2682 329.175L69.2281 344.501L58.0442 355.094L54.7609 383.277L69.7208 398.997L64.2874 404.339L58.0442 410.525L55.6414 431.436C134.268 514.126 245.535 570.529 382.823 573.111Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 1.5,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__seats-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_156"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_168",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.479 528.73L172.354 521.428C127.629 497.668 87.2266 466.505 52.8408 429.305L46.7836 434.913C81.7812 472.806 122.917 504.521 168.479 528.73Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.560079,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_157"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_169",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M598.503 528.73L594.627 521.428C639.353 497.668 679.755 466.505 714.141 429.305L720.198 434.913C685.201 472.806 644.065 504.521 598.503 528.73Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.560079,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_158"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_170",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M308.49 576.107L309.837 567.968C266.946 560.851 225.3 547.533 186.203 528.484L182.593 535.908C222.404 555.324 264.804 568.867 308.49 576.107Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.560079,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_159"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_171",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.493 576.107L457.146 567.968C500.037 560.851 541.684 547.533 580.781 528.484L584.39 535.908C544.58 555.324 502.179 568.867 458.493 576.107Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.560079,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_160"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_172",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M442.791 578.472L441.73 570.273C422.437 572.782 403.021 574.046 383.584 574.046C364.128 574.046 344.712 572.782 325.418 570.273L324.358 578.472C343.998 581.021 363.781 582.306 383.584 582.306C403.367 582.306 423.151 581.021 442.791 578.472Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.560079,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_161"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_173",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.386 536.124L159.495 528.702C119.515 506.564 83.0169 478.639 51.2139 445.83L45.1347 451.742C77.5037 485.159 114.652 513.608 155.386 536.124Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.575719,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_162"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_174",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M611.596 536.124L607.487 528.702C647.466 506.564 683.965 478.639 715.768 445.83L721.847 451.742C689.478 485.159 652.33 513.608 611.596 536.124Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.575719,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_163"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_175",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M277.274 582.918L279.182 574.657C245.156 566.775 212.116 555.056 180.711 539.752L177.001 547.383C208.971 562.981 242.599 574.889 277.274 582.918Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.575719,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_164"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_176",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M489.707 582.918L487.799 574.657C521.824 566.775 554.864 555.056 586.269 539.752L589.98 547.383C558.009 562.981 524.382 574.889 489.707 582.918Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.575719,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_165"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_177",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M417.525 593.86L416.916 585.391C405.826 586.187 394.715 586.586 383.604 586.586C372.472 586.586 361.362 586.187 350.271 585.391L349.664 593.86C360.963 594.657 372.262 595.076 383.604 595.076C394.925 595.076 406.247 594.657 417.525 593.86Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.575719,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_166"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_178",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M137.435 541.47L141.877 533.944C116.472 518.976 92.5111 501.68 70.3188 482.27L64.5611 488.868C87.1848 508.624 111.576 526.223 137.435 541.47Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.592263,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_167"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_179",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M629.547 541.47L625.104 533.944C650.51 518.976 674.471 501.68 696.663 482.27L702.421 488.868C679.797 508.624 655.406 526.223 629.547 541.47Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.592263,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_168"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_180",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M275.699 596.44L277.662 587.921C249.453 581.494 221.89 572.501 195.32 561.049L191.87 569.072C218.915 580.74 246.994 589.884 275.699 596.44Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.592263,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_169"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_181",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M491.282 596.44L489.319 587.921C517.529 581.494 545.091 572.501 571.661 561.049L575.112 569.072C548.067 580.74 519.987 589.884 491.282 596.44Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.592263,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_170"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_182",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M417.523 607.42L416.898 598.707C405.813 599.483 394.706 599.872 383.599 599.872C372.47 599.872 361.364 599.483 350.278 598.707L349.653 607.42C360.954 608.218 372.276 608.606 383.599 608.606C394.9 608.606 406.222 608.218 417.523 607.42Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.592263,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_171"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_183",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.791 552.763L135.353 545.033C114.092 532.52 93.8272 518.412 74.714 502.82L69.0663 509.775C88.5117 525.655 109.153 540.006 130.791 552.763Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.608206,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_172"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_184",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.191 552.763L631.629 545.033C652.89 532.52 673.155 518.412 692.268 502.82L697.916 509.775C678.47 525.655 657.829 540.006 636.191 552.763Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.608206,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_173"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_185",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M273.243 609.33L275.237 600.581C254.175 595.798 233.445 589.618 213.18 582.088L210.057 590.504C230.676 598.167 251.782 604.458 273.243 609.33Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.608206,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_174"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_186",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M493.739 609.33L491.745 600.581C512.807 595.798 533.537 589.618 553.802 582.088L556.925 590.504C536.306 598.167 515.2 604.458 493.739 609.33Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.608206,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_175"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_187",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.579 620.912L411.069 611.963C401.923 612.472 392.753 612.739 383.584 612.739C374.393 612.739 365.224 612.472 356.077 611.963L355.568 620.912C364.893 621.443 374.238 621.708 383.584 621.708C392.908 621.708 402.255 621.443 411.579 620.912Z",
  fill: "white",
  stroke: "#281E64",
  strokeWidth: 0.608206,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "1.22 1.22"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__lines"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_176"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_188",
  d: "M618.583 24.4004H152.399L152.399 31.9407H618.583L618.583 24.4004Z",
  stroke: "#141941",
  strokeWidth: 1.58,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_177"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_189",
  d: "M382.005 213.844C432.227 213.844 472.94 173.131 472.94 122.909C472.94 72.6874 432.227 31.9746 382.005 31.9746C331.783 31.9746 291.07 72.6874 291.07 122.909C291.07 173.131 331.783 213.844 382.005 213.844Z",
  stroke: "#8496B9",
  strokeWidth: 1.20033,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__walls"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_178"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_190",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M580.062 24.7155V4.54228H547.134V1H545.849V5.82712H578.778V24.7155H580.062Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_179"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_191",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.406 24.7155V4.54228H219.335V1H220.62V5.82712H187.691V24.7155H186.406Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__wall-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_180"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_192",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.0698 429.749L95.0688 429.748L128.301 395.246L130.43 397.296L99.2843 429.631C123.359 451.806 149.126 470.304 180.136 488.514L200.904 449.306L203.515 450.689L181.31 492.606L178.699 491.222C146.766 472.738 120.894 453.904 97.2189 431.774L97.1968 431.798L95.2077 429.881C95.1614 429.838 95.1151 429.794 95.0688 429.75L95.0698 429.749Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_181"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_193",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M672.054 429.75L672.055 429.749L639.886 396.352L637.758 398.401L667.84 429.633C643.792 451.823 618.235 470.814 587.252 489.012L566.697 450.208L564.086 451.592L586.018 492.996L588.569 491.642L588.629 491.76C620.562 473.273 646.242 453.936 669.905 431.776L669.927 431.799L671.915 429.883C671.962 429.839 672.008 429.795 672.055 429.751L672.054 429.75Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_182"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_194",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M207.76 502.49C237.527 516.203 268.412 525.866 303.521 533.671L311.271 489.838L314.18 490.353L305.882 537.287C273.937 531.999 230.948 517.341 203.8 503.907L204.535 502.404L204.518 502.396L224.631 461.233L227.286 462.53L207.76 502.49Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_183"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_195",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M339.356 501.765L335.405 528.804L332.481 528.377L336.856 498.438L338.318 498.651C373.834 502.922 395.089 501.772 428.673 498.384L431.601 497.989L435.741 528.605L432.812 529L429.084 501.426C395.457 505.068 373.857 506.014 339.356 501.765ZM331.163 537.419C364.676 541.795 400.333 542.01 437.222 538.66L437.631 541.698C399.792 545.374 363.856 544.923 330.734 540.343L331.163 537.419Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_184"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_196",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M563.587 504.366L563.589 504.366L542.558 461.325L539.903 462.622L559.632 502.999C529.093 517.615 498.48 526.966 464.462 533.459L456.725 489.701L453.815 490.216L462.085 536.997L464.995 536.482C501.992 529.585 533.364 519.29 563.588 504.368L563.587 504.366Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_197",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M132.203 123.052L132.225 123.074L84.7697 170.529L81.9839 167.746L129.439 120.288L129.44 120.29C132.709 117.009 134.545 112.566 134.545 107.933C134.545 103.49 132.857 99.2204 129.834 95.9839L127.048 93.1981L181.879 38.3668V32.373H185.819V39.9663L185.835 39.9826L185.819 39.9988V40.0269H185.791L132.598 93.2202C136.352 97.1904 138.452 102.453 138.452 107.933C138.452 113.602 136.204 119.039 132.203 123.052Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_185"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_198",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M635.007 123.052L634.985 123.074L682.44 170.529L685.226 167.746L637.77 120.288L637.769 120.29C634.5 117.009 632.664 112.566 632.664 107.933C632.664 103.49 634.353 99.2204 637.375 95.9839L640.161 93.1981L585.33 38.3668V32.373H581.39V39.9663L581.374 39.9826L581.39 39.9988V40.0269H581.418L634.612 93.2202C630.857 97.1904 628.757 102.453 628.757 107.933C628.757 113.602 631.005 119.039 635.007 123.052Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_186"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_199",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M575.584 43.5719H668.329V42.287H576.149L569.006 35.1444V24.6934H549.896V25.9782H567.721V35.7073H567.752L575.584 43.5394V43.5719Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_187"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_200",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M190.882 43.5719H98.1367V42.287H190.317L197.46 35.1444V25.9782H188.666V24.6934H216.57V25.9782H198.745V35.7073H198.714L190.882 43.5394V43.5719Z",
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "speaker-distribution_svg__Rectangle 54",
  x: 1.47363,
  y: 24.293,
  width: 196.637,
  height: 7.64701,
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "speaker-distribution_svg__Rectangle 55",
  x: 567.646,
  y: 24.4004,
  width: 203.879,
  height: 7.8794,
  fill: "#D1DAE9",
  stroke: "#141941",
  strokeWidth: 1.20362,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Speakers"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__LFE"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_188"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_201",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.103 10.7168L371.607 26.4781H340.071L340.576 10.7168H371.103Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.77249,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_202",
  d: "M340.418 13.0527H371.27",
  stroke: "#6E32F0",
  strokeWidth: 0.599558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_203",
  d: "M340.418 15.2383H371.27",
  stroke: "#6E32F0",
  strokeWidth: 0.599558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_204",
  d: "M340.418 17.4219H371.27",
  stroke: "#6E32F0",
  strokeWidth: 0.599558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_205",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.103 10.7168L371.607 26.4781H340.071L340.576 10.7168H371.103Z",
  fill: "#6E32F0",
  fillOpacity: 0.25,
  stroke: "#6E32F0",
  strokeWidth: 1.77249,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_189"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_190"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_206",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M428.468 10.7168L428.961 26.4781H398.157L398.649 10.7168H428.468Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.77249,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_191"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_207",
  d: "M398.494 13.0527H428.629",
  stroke: "#6E32F0",
  strokeWidth: 0.599558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_192"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_208",
  d: "M398.494 15.2383H428.629",
  stroke: "#6E32F0",
  strokeWidth: 0.599558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_193"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_209",
  d: "M398.494 17.4219H428.629",
  stroke: "#6E32F0",
  strokeWidth: 0.599558,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_210",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M428.07 11.1836L428.559 26.4776H397.971L398.46 11.1836H428.07Z",
  fill: "#6E32F0",
  fillOpacity: 0.25
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Fill"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_194"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_211",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.49 17.0776C264.962 19.9414 263.431 22.8034 261.902 25.6672L246.547 16.802C248.236 14.0307 249.927 11.2612 251.619 8.49175L266.49 17.0776Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 1.7741,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_212",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M265.439 19.0446C263.894 21.9365 262.35 24.8284 260.802 27.7186L245.335 18.7888C247.04 15.9894 248.748 13.1918 250.456 10.3941L265.439 19.0446Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 0.592577,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_213",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.377 21.0308C262.816 23.9509 261.258 26.8732 259.697 29.7933L244.109 20.7937C245.833 17.9678 247.558 15.1416 249.282 12.3158L264.377 21.0308Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 0.592577,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_214",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M263.306 23.0384C261.729 25.9874 260.154 28.9382 258.577 31.8869L242.871 22.8192C244.615 19.9665 246.355 17.1117 248.099 14.2587L263.306 23.0384Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 0.592577,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_215",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M262.222 25.0639C260.631 28.0436 259.04 31.023 257.449 34.0027L241.625 24.867C243.383 21.9832 245.143 19.1016 246.901 16.2179L262.222 25.0639Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 1.7741,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_216",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.49 17.0757C263.475 22.7168 260.46 28.358 257.448 34.0009L241.625 24.8651C244.954 19.4055 248.287 13.9476 251.619 8.48979L266.49 17.0757Z",
  fill: "#321E78",
  fillOpacity: 0.2
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group 256"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_217",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M503.744 17.0776C505.272 19.9414 506.803 22.8034 508.332 25.6672L523.687 16.802C521.998 14.0307 520.306 11.2612 518.615 8.49175L503.744 17.0776Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 1.7741,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_218",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.796 19.0446C506.34 21.9365 507.885 24.8284 509.433 27.7186L524.9 18.7888C523.195 15.9894 521.487 13.1918 519.779 10.3941L504.796 19.0446Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 0.592577,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_219",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M505.859 21.0308C507.419 23.9509 508.978 26.8732 510.539 29.7933L526.126 20.7937C524.402 17.9678 522.678 15.1416 520.953 12.3158L505.859 21.0308Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 0.592577,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_220",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M506.929 23.0384C508.507 25.9874 510.081 28.9382 511.659 31.8869L527.365 22.8192C525.621 19.9665 523.88 17.1117 522.136 14.2587L506.929 23.0384Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 0.592577,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_221",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M508.013 25.0639C509.604 28.0436 511.195 31.023 512.787 34.0027L528.61 24.867C526.853 21.9832 525.092 19.1016 523.335 16.2179L508.013 25.0639Z",
  fill: "white",
  stroke: "#321E78",
  strokeWidth: 1.7741,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_222",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M503.746 17.0776C506.761 22.7188 509.776 28.3599 512.788 34.0028L528.611 24.8671C525.282 19.4075 521.949 13.9496 518.617 8.49174L503.746 17.0776Z",
  stroke: "#321E78",
  strokeWidth: 1.49543,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_223",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M503.745 17.0776C506.76 22.7188 509.775 28.3599 512.787 34.0028L528.61 24.8671C525.281 19.4075 521.948 13.9496 518.616 8.49174L503.745 17.0776Z",
  fill: "#321E78",
  fillOpacity: 0.2,
  stroke: "#321E78",
  strokeWidth: 1.49543,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Main"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_195"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_196"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_224",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.668 8.12372C233.643 11.2212 234.613 14.3199 235.588 17.4174L213.431 23.3544C212.687 20.1949 211.948 17.0343 211.209 13.8736L232.668 8.12372Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_197"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_225",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.337 10.2523C234.32 13.3813 235.303 16.5102 236.282 19.6403L213.964 25.6205C213.212 22.4296 212.464 19.2376 211.716 16.0455L233.337 10.2523Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_198"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_226",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.011 12.4032C235.003 15.5636 235.999 18.7232 236.991 21.8835L214.498 27.9105C213.742 24.687 212.985 21.4631 212.229 18.2396L234.011 12.4032Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_199"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_227",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.695 14.5725C235.695 17.7651 236.7 20.9566 237.7 24.1488L215.037 30.2213C214.277 26.9648 213.512 23.7091 212.752 20.4522L234.695 14.5725Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_200"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_228",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M235.381 16.7655C236.395 19.9893 237.408 23.2126 238.422 26.4364L215.588 32.5545C214.815 29.2665 214.046 25.9777 213.272 22.6896L235.381 16.7655Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_201"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_229",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M232.668 8.12468C234.585 14.2296 236.501 20.3345 238.422 26.4383L215.588 32.5564C214.126 26.3299 212.667 20.1023 211.209 13.8746L232.668 8.12468Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_202"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_203"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_230",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.525 77.9234C154.918 80.1184 157.308 82.3167 159.701 84.5117L143.481 100.732C141.257 98.3675 139.036 96 136.816 93.6324L152.525 77.9234Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_204"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_231",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154.168 79.4322C156.585 81.6502 159.001 83.8682 161.414 86.0895L145.075 102.428C142.828 100.04 140.585 97.6499 138.341 95.2593L154.168 79.4322Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_205"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_232",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.827 80.9572C158.267 83.1983 160.709 85.4365 163.148 87.6775L146.682 104.144C144.416 101.73 142.149 99.3162 139.882 96.9026L155.827 80.9572Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_206"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_233",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M157.506 82.4948C159.968 84.7595 162.434 87.021 164.897 89.2853L148.306 105.876C146.019 103.436 143.729 100.999 141.442 98.5584L157.506 82.4948Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_207"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_234",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.197 84.0485C161.686 86.3336 164.175 88.6184 166.665 90.9036L149.95 107.619C147.636 105.158 145.326 102.694 143.012 100.233L159.197 84.0485Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_208"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_235",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.526 77.9215C157.238 82.2503 161.95 86.5792 166.665 90.9048L149.95 107.62C145.57 102.959 141.193 98.2948 136.817 93.6306L152.526 77.9215Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_209"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_210"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_236",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.919 77.9214C613.526 80.1165 611.136 82.3147 608.743 84.5098L624.963 100.73C627.187 98.3655 629.407 95.998 631.628 93.6305L615.919 77.9214Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_211"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_237",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M614.276 79.4322C611.86 81.6502 609.444 83.8682 607.031 86.0895L623.37 102.428C625.616 100.04 627.86 97.6499 630.104 95.2593L614.276 79.4322Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_212"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_238",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M612.618 80.9572C610.179 83.1983 607.736 85.4365 605.297 87.6775L621.763 104.144C624.03 101.73 626.297 99.3162 628.563 96.9026L612.618 80.9572Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_213"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_239",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M610.941 82.4928C608.478 84.7575 606.012 87.019 603.55 89.2834L620.14 105.874C622.427 103.434 624.717 100.997 627.004 98.5564L610.941 82.4928Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_214"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_240",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M609.249 84.0485C606.76 86.3336 604.27 88.6184 601.781 90.9036L618.496 107.619C620.81 105.158 623.12 102.694 625.434 100.233L609.249 84.0485Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_215"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_241",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.919 77.9215C611.207 82.2503 606.495 86.5792 601.78 90.9048L618.495 107.62C622.875 102.959 627.251 98.2948 631.628 93.6306L615.919 77.9215Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_216"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_217"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_242",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.6038 159.196C93.4835 160.696 96.3609 162.201 99.2406 163.702L87.7712 183.568C85.0113 181.859 82.2536 180.147 79.4959 178.435L90.6038 159.196Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_218"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_243",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.581 160.227C95.4888 161.744 98.3966 163.261 101.302 164.782L89.7493 184.792C86.9612 183.068 84.1753 181.339 81.3894 179.611L92.581 160.227Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_219"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_244",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.5784 161.273C97.5144 162.807 100.453 164.336 103.389 165.87L91.7458 186.037C88.9318 184.292 86.1174 182.547 83.3033 180.802L94.5784 161.273Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_220"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_245",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.5972 162.322C99.5621 163.872 102.529 165.418 105.494 166.968L93.7625 187.287C90.9222 185.522 88.0792 183.761 85.2385 181.996L96.5972 162.322Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_221"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_246",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.6334 163.388C101.63 164.951 104.625 166.514 107.621 168.077L95.802 188.548C92.9301 186.77 90.0608 184.989 87.1889 183.211L98.6334 163.388Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_222"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_247",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.3911 159.373C96.063 162.335 101.735 165.296 107.409 168.254L95.5897 188.726C90.1527 185.357 84.7179 181.985 79.2831 178.613L90.3911 159.373Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_223"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_224"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_248",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M677.838 159.196C674.958 160.696 672.08 162.201 669.201 163.702L680.67 183.568C683.43 181.859 686.188 180.147 688.946 178.435L677.838 159.196Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_225"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_249",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M675.859 160.229C672.951 161.746 670.043 163.263 667.137 164.784L678.69 184.794C681.478 183.07 684.264 181.341 687.05 179.613L675.859 160.229Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_226"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_250",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M673.862 161.271C670.926 162.805 667.988 164.334 665.052 165.868L676.695 186.035C679.509 184.29 682.324 182.545 685.138 180.8L673.862 161.271Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_227"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_251",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M671.843 162.322C668.878 163.872 665.911 165.418 662.947 166.968L674.678 187.287C677.518 185.522 680.361 183.761 683.202 181.996L671.843 162.322Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_228"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_252",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M669.807 163.39C666.811 164.953 663.815 166.516 660.819 168.079L672.638 188.55C675.51 186.772 678.38 184.991 681.252 183.213L669.807 163.39Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_229"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_253",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M677.836 159.197C672.164 162.159 666.492 165.121 660.818 168.078L672.637 188.55C678.074 185.182 683.509 181.809 688.944 178.437L677.836 159.197Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_230"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_231"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_254",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.5776 358.733C53.8219 358.593 57.0662 358.457 60.3105 358.317V381.256C57.0662 381.156 53.8219 381.053 50.5776 380.949V358.733Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_232"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_255",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.8066 358.638C56.0835 358.498 59.3603 358.358 62.6371 358.222V381.328C59.3603 381.229 56.0835 381.125 52.8066 381.021V358.638Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_233"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_256",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.0576 358.544C58.367 358.404 61.6768 358.26 64.9861 358.12V381.406C61.6768 381.302 58.367 381.198 55.0576 381.095V358.544Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_234"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_257",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.3311 358.446C60.6738 358.306 64.0166 358.162 67.3589 358.022V381.484C64.0166 381.376 60.6738 381.272 57.3311 381.164V358.446Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_235"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_258",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.6279 358.351C63.0041 358.207 66.3799 358.062 69.7561 357.918V381.557C66.3799 381.453 63.0041 381.344 59.6279 381.24V358.351Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_236"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_259",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.5776 358.735C56.9705 358.464 63.3634 358.193 69.7563 357.918V381.557C63.3634 381.358 56.9705 381.155 50.5776 380.951V358.735Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_237"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_238"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_260",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.866 358.733C714.622 358.593 711.378 358.457 708.133 358.317V381.256C711.378 381.156 714.622 381.053 717.866 380.949V358.733Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_239"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_261",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M715.638 358.638C712.361 358.498 709.084 358.358 705.807 358.222V381.328C709.084 381.229 712.361 381.125 715.638 381.021V358.638Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_240"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_262",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M713.386 358.544C710.076 358.404 706.767 358.26 703.457 358.12V381.406C706.767 381.302 710.076 381.198 713.386 381.095V358.544Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_241"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_263",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M711.113 358.446C707.771 358.306 704.428 358.162 701.085 358.022V381.484C704.428 381.376 707.771 381.272 711.113 381.164V358.446Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_242"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_264",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M708.816 358.351C705.44 358.207 702.064 358.062 698.688 357.918V381.557C702.064 381.453 705.44 381.344 708.816 381.24V358.351Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_243"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_265",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.866 358.735C711.473 358.464 705.08 358.193 698.688 357.918V381.557C705.08 381.358 711.473 381.155 717.866 380.951V358.735Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_244"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_245"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_266",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.5776 249.573C53.8219 249.433 57.0662 249.297 60.3105 249.157V272.096C57.0662 271.996 53.8219 271.892 50.5776 271.789V249.573Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_246"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_267",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.8066 249.478C56.0835 249.338 59.3603 249.198 62.6371 249.062V272.168C59.3603 272.069 56.0835 271.965 52.8066 271.861V249.478Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_247"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_268",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.0576 249.382C58.367 249.242 61.6768 249.098 64.9861 248.958V272.244C61.6768 272.14 58.367 272.036 55.0576 271.932V249.382Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_248"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_269",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.3311 249.282C60.6738 249.142 64.0166 248.998 67.3589 248.858V272.32C64.0166 272.212 60.6738 272.108 57.3311 272V249.282Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_249"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_270",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.6279 249.187C63.0041 249.043 66.3799 248.898 69.7561 248.754V272.393C66.3799 272.289 63.0041 272.18 59.6279 272.076V249.187Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_250"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_271",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.5776 249.571C56.9705 249.3 63.3634 249.029 69.7563 248.754V272.393C63.3634 272.194 56.9705 271.991 50.5776 271.787V249.571Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_251"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_252"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_272",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.866 249.573C714.622 249.433 711.378 249.297 708.133 249.157V272.096C711.378 271.996 714.622 271.892 717.866 271.789V249.573Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_253"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_273",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M715.638 249.478C712.361 249.338 709.084 249.198 705.807 249.062V272.168C709.084 272.069 712.361 271.965 715.638 271.861V249.478Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_254"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_274",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M713.386 249.382C710.076 249.242 706.767 249.098 703.457 248.958V272.244C706.767 272.14 710.076 272.036 713.386 271.932V249.382Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_255"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_275",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M711.113 249.282C707.771 249.142 704.428 248.998 701.085 248.858V272.32C704.428 272.212 707.771 272.108 711.113 272V249.282Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_256"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_276",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M708.816 249.187C705.44 249.043 702.064 248.898 698.688 248.754V272.393C702.064 272.289 705.44 272.18 708.816 272.076V249.187Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_257"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_277",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.866 249.571C711.473 249.3 705.08 249.029 698.688 248.754V272.393C705.08 272.194 711.473 271.991 717.866 271.787V249.571Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_258"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_259"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_278",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M538.319 8.12568C537.344 11.2232 536.373 14.3219 535.398 17.4194L557.555 23.3563C558.299 20.1969 559.038 17.0362 559.778 13.8756L538.319 8.12568Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_260"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_279",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.649 10.2523C536.666 13.3813 535.683 16.5102 534.704 19.6403L557.022 25.6205C557.774 22.4296 558.522 19.2376 559.27 16.0455L537.649 10.2523Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_261"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_280",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M536.976 12.4032C535.984 15.5636 534.988 18.7232 533.996 21.8835L556.489 27.9105C557.245 24.687 558.001 21.4631 558.757 18.2396L536.976 12.4032Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_262"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_281",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M536.292 14.5744C535.291 17.7671 534.287 20.9585 533.286 24.1507L555.95 30.2233C556.71 26.9668 557.475 23.711 558.235 20.4541L536.292 14.5744Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_263"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_282",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M535.605 16.7675C534.592 19.9912 533.578 23.2146 532.565 26.4383L555.398 32.5565C556.172 29.2684 556.941 25.9797 557.714 22.6916L535.605 16.7675Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_264"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_283",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M538.319 8.12468C536.402 14.2296 534.486 20.3345 532.565 26.4383L555.398 32.5564C556.861 26.3299 558.319 20.1023 559.778 13.8746L538.319 8.12468Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_265"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_266"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_284",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.759 8.12568C291.734 11.2232 292.705 14.3219 293.68 17.4194L271.522 23.3563C270.779 20.1969 270.039 17.0362 269.3 13.8756L290.759 8.12568Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_267"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_285",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M291.428 10.2543C292.411 13.3832 293.395 16.5121 294.374 19.6422L272.055 25.6225C271.303 22.4316 270.555 19.2395 269.807 16.0474L291.428 10.2543Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_268"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_286",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M292.102 12.4052C293.094 15.5655 294.09 18.7251 295.082 21.8855L272.589 27.9125C271.833 24.689 271.077 21.4651 270.321 18.2416L292.102 12.4052Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_269"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_287",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M292.786 14.5744C293.787 17.7671 294.791 20.9585 295.792 24.1507L273.129 30.2233C272.368 26.9668 271.603 23.711 270.843 20.4541L292.786 14.5744Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_270"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_288",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.473 16.7675C294.486 19.9912 295.499 23.2146 296.513 26.4383L273.679 32.5565C272.906 29.2684 272.137 25.9797 271.364 22.6916L293.473 16.7675Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_271"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_289",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.76 8.12663C292.676 14.2315 294.593 20.3365 296.513 26.4402L273.68 32.5584C272.218 26.3319 270.759 20.1042 269.301 13.8765L290.76 8.12663Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_272"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_290",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.23 8.12177C479.255 11.2193 478.284 14.3179 477.309 17.4155L499.466 23.3524C500.21 20.193 500.949 17.0323 501.689 13.8717L480.23 8.12177Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_291",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M479.561 10.2504C478.578 13.3793 477.595 16.5082 476.616 19.6383L498.934 25.6186C499.686 22.4277 500.434 19.2356 501.182 16.0435L479.561 10.2504Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_292",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M478.888 12.4013C477.896 15.5616 476.9 18.7212 475.908 21.8816L498.401 27.9086C499.157 24.6851 499.913 21.4612 500.67 18.2377L478.888 12.4013Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_293",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M478.203 14.5705C477.203 17.7631 476.198 20.9546 475.198 24.1468L497.861 30.2194C498.621 26.9629 499.386 23.7071 500.147 20.4502L478.203 14.5705Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599584,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_294",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M477.517 16.7675C476.504 19.9912 475.49 23.2146 474.477 26.4383L497.31 32.5565C498.084 29.2684 498.853 25.9797 499.626 22.6916L477.517 16.7675Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_295",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M480.229 8.12273C478.312 14.2276 476.396 20.3326 474.475 26.4363L497.309 32.5545C498.771 26.328 500.23 20.1003 501.688 13.8726L480.229 8.12273Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_273"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_296",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.16 9.21085C337.748 12.4044 338.332 15.5987 338.92 18.7923L316.203 21.971C315.852 18.7443 315.505 15.5169 315.158 12.2895L337.16 9.21085Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_297",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.561 11.4064C338.154 14.6322 338.747 17.858 339.335 21.0845L316.452 24.2864C316.096 21.0274 315.745 17.7678 315.394 14.5082L337.561 11.4064Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_298",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.967 13.6229C338.564 16.8809 339.166 20.1387 339.763 23.3968L316.702 26.6237C316.346 23.3319 315.99 20.0396 315.634 16.7478L337.967 13.6229Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_299",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.382 15.8602C338.984 19.1513 339.59 22.4418 340.192 25.7325L316.956 28.9839C316.6 25.6588 316.239 22.3338 315.884 19.0083L338.382 15.8602Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_300",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.793 18.1222C339.404 21.4458 340.015 24.769 340.626 28.0926L317.216 31.3683C316.851 28.0103 316.49 24.6521 316.125 21.2941L338.793 18.1222Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_301",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.159 9.21055C338.313 15.5042 339.467 21.7979 340.626 28.0909L317.215 31.3667C316.526 25.0079 315.842 18.6486 315.157 12.2892L337.159 9.21055Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_274"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_302",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M433.828 9.21085C433.24 12.4044 432.656 15.5987 432.068 18.7923L454.785 21.971C455.136 18.7443 455.483 15.5169 455.83 12.2895L433.828 9.21085Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_303",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M433.425 11.4064C432.832 14.6322 432.239 17.858 431.651 21.0845L454.534 24.2864C454.889 21.0274 455.241 17.7678 455.592 14.5082L433.425 11.4064Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_304",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M433.018 13.6229C432.421 16.8809 431.819 20.1387 431.221 23.3968L454.283 26.6237C454.639 23.3319 454.995 20.0396 455.35 16.7478L433.018 13.6229Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_305",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.606 15.8602C432.004 19.1513 431.397 22.4418 430.795 25.7325L454.032 28.9839C454.388 25.6588 454.748 22.3338 455.104 19.0083L432.606 15.8602Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_306",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M432.193 18.1222C431.582 21.4458 430.972 24.769 430.361 28.0926L453.771 31.3683C454.136 28.0103 454.497 24.6521 454.862 21.2941L432.193 18.1222Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_307",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M433.827 9.2086C432.673 15.5023 431.519 21.7959 430.36 28.089L453.771 31.3647C454.46 25.006 455.144 18.6466 455.829 12.2872L433.827 9.2086Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_275"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_308",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M396.497 10.6445C396.637 13.8888 396.772 17.1331 396.912 20.3774H373.974C374.073 17.1331 374.177 13.8888 374.281 10.6445H396.497Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_309",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M396.592 12.873C396.732 16.1499 396.872 19.4267 397.008 22.7035H373.902C374.001 19.4267 374.105 16.1499 374.209 12.873H396.592Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_310",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M396.688 15.125C396.828 18.4344 396.973 21.7442 397.113 25.0535H373.826C373.93 21.7442 374.034 18.4344 374.138 15.125H396.688Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_311",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M396.787 17.3984C396.927 20.7412 397.071 24.084 397.211 27.4263H373.749C373.857 24.084 373.961 20.7412 374.069 17.3984H396.787Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 0.599585,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_312",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M396.881 19.6953C397.026 23.0715 397.17 26.4473 397.315 29.8235H373.676C373.78 26.4473 373.888 23.0715 373.992 19.6953H396.881Z",
  fill: "white",
  stroke: "#1EC8FA",
  strokeWidth: 1.80289,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_313",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M396.497 10.6445C396.768 17.0374 397.039 23.4303 397.315 29.8232H373.676C373.875 23.4303 374.078 17.0374 374.281 10.6445L396.497 10.6445Z",
  fill: "#1EC8FA",
  fillOpacity: 0.25,
  stroke: "#1EC8FA",
  strokeWidth: 1.632,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Ceiling"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_276"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_277"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_314",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.995 188.498L208.582 181.781L213.937 191.303L202.179 197.715L196.995 188.498Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.4364,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_278"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_315"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M210.706 192.631L205.467 183.315L210.706 192.631Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.706 192.631L205.467 183.315",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_279"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_280"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_316",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M284.893 273.13L291.041 261.232L300.68 266.374L294.223 278.107L284.893 273.13Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.4364,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_281"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_317"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M299.463 269.129L290.034 264.099L299.463 269.129Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.463 269.129L290.034 264.099",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_282"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_283"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_318",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.57 298.293L376.395 284.902H387.319L387.145 298.293H376.57Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.4364,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_284"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_319"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.201 287.494H376.514H387.201Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.201 287.494H376.514",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_285"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_286"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_320",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.506 403.681L252.089 391.977L261.885 396.813L255.988 408.362L246.506 403.681Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.45439,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_287"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_321"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M259.293 401.795L249.71 397.064L259.293 401.795Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.293 401.795L249.71 397.064",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_288"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_289"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_322",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.061 322.871L148.106 313.579L155.831 321.304L146.539 330.349L139.061 322.871Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.45439,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_290"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_323"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M151.776 325.189L144.219 317.632L151.776 325.189Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.776 325.189L144.219 317.632",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_291"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_292"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_324",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.57 569.158L376.395 558.404H387.319L387.145 569.158H376.57Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55462,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_293"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_325"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.201 564.758H376.514H387.201Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.201 564.758H376.514",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_294"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_295"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_326",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M304.46 559.397L306.198 548.783L316.949 550.723L314.867 561.276L304.46 559.397Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_296"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_327"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M315.702 556.959L305.184 555.061L315.702 556.959Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.702 556.959L305.184 555.061",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_297"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_298"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_328",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M231.86 540.484L235.407 530.33L245.66 534.1L241.785 544.133L231.86 540.484Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_299"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_329"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.354 540.027L233.323 536.339L243.354 540.027Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.354 540.027L233.323 536.339",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_300"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_301"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_330",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.007 506.843L164.528 497.612L173.811 503.371L167.994 512.418L159.007 506.843Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_302"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_331"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M170.358 508.709L161.276 503.075L170.358 508.709Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.358 508.709L161.276 503.075",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_303"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_304"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_332",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.2762 456.595L96.0861 448.269L104.429 455.323L97.352 463.422L89.2762 456.595Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_305"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_333"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.233 460.1L92.0713 453.199L100.233 460.1Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.233 460.1L92.0713 453.199",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_306"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_307"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_334",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M566.718 188.369L555.132 181.652L549.777 191.174L561.534 197.586L566.718 188.369Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.4364,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_308"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_335"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M553.008 192.502L558.247 183.187L553.008 192.502Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553.008 192.502L558.247 183.187",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_309"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_310"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_336",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M478.821 273.003L472.673 261.105L463.034 266.247L469.491 277.98L478.821 273.003Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.4364,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_311"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_337"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M464.25 269L473.68 263.97L464.25 269Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M464.25 269L473.68 263.97",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_312"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_313"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_338",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M517.208 403.548L511.625 391.844L501.829 396.68L507.726 408.229L517.208 403.548Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.45439,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_314"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_339"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.423 401.66L514.006 396.929L504.423 401.66Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504.423 401.66L514.006 396.929",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_315"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_316"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_340",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M624.656 322.737L615.611 313.445L607.886 321.169L617.178 330.214L624.656 322.737Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.45439,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_317"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_341"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M611.939 325.055L619.497 317.497L611.939 325.055Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.939 325.055L619.497 317.497",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_318"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_319"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_342",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M459.255 559.263L457.516 548.648L446.766 550.588L448.848 561.141L459.255 559.263Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_320"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_343"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.013 556.822L458.53 554.924L448.013 556.822Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M448.013 556.822L458.53 554.924",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_321"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_322"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_344",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M531.854 540.355L528.307 530.201L518.053 533.971L521.929 544.004L531.854 540.355Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_323"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_345"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M520.359 539.895L530.39 536.206L520.359 539.895Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.359 539.895L530.39 536.206",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_324"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_325"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_346",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M604.707 506.714L599.186 497.483L589.903 503.242L595.721 512.289L604.707 506.714Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_326"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_347"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M593.356 508.58L602.438 502.946L593.356 508.58Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M593.356 508.58L602.438 502.946",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_327"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_328"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_348",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M674.438 456.468L667.628 448.142L659.286 455.196L666.362 463.295L674.438 456.468Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.55463,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_329"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_349"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M663.482 459.973L671.644 453.073L663.482 459.973Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M663.482 459.973L671.644 453.073",
  stroke: "#4682FA",
  strokeWidth: 0.429249,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_330"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_331"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Vector_350",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M376.57 435.102L376.395 422.135H387.319L387.145 435.102H376.57Z",
  fill: "#E1EBFE",
  stroke: "#4682FA",
  strokeWidth: 1.45439,
  strokeMiterlimit: 2,
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Group_332"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Vector_351"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.201 427.752H376.514H387.201Z",
  fill: "#E1EBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.201 427.752H376.514",
  stroke: "#4682FA",
  strokeWidth: 0.429248,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__label-lfe",
  className: "label-lfe",
  filter: "url(#speaker-distribution_svg__filter0_d_2851_19726)"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Frame 4"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Polygon 4",
  d: "M355.5 27L360.5 35H355.5H350.5L355.5 27Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__text"
}, /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: 35,
  width: 37,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Tooltip",
  d: "M346.077 52V43.54H347.625V50.692H351.609V52H346.077ZM352.791 52V43.54H358.371V44.752H354.339V47.152H358.095V48.364H354.339V52H352.791ZM359.659 52V43.54H365.359V44.752H361.147V47.092H365.083V48.316H361.147V50.776H365.359V52H359.659Z",
  fill: "#141941"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__label-front-fills",
  className: "label-front-fills",
  filter: "url(#speaker-distribution_svg__filter1_d_2851_19726)"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__Frame 4_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Polygon 4_2",
  d: "M526 34L531 42H526H521L526 34Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__text_2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 490,
  y: 42,
  width: 72,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Tooltip_2",
  d: "M499.034 59V50.54H504.614V51.752H500.582V54.152H504.338V55.364H500.582V59H499.034ZM505.652 59V54.488C505.652 54.232 505.644 53.972 505.628 53.708C505.62 53.444 505.6 53.188 505.568 52.94H507.02L507.188 54.596H506.948C507.028 54.196 507.16 53.864 507.344 53.6C507.536 53.336 507.768 53.14 508.04 53.012C508.312 52.884 508.608 52.82 508.928 52.82C509.072 52.82 509.188 52.828 509.276 52.844C509.364 52.852 509.452 52.872 509.54 52.904L509.528 54.224C509.376 54.16 509.244 54.12 509.132 54.104C509.028 54.088 508.896 54.08 508.736 54.08C508.392 54.08 508.1 54.152 507.86 54.296C507.628 54.44 507.452 54.64 507.332 54.896C507.22 55.152 507.164 55.444 507.164 55.772V59H505.652ZM513.017 59.12C512.393 59.12 511.853 58.992 511.397 58.736C510.941 58.48 510.585 58.116 510.329 57.644C510.081 57.172 509.957 56.612 509.957 55.964C509.957 55.316 510.081 54.76 510.329 54.296C510.585 53.824 510.941 53.46 511.397 53.204C511.853 52.948 512.393 52.82 513.017 52.82C513.641 52.82 514.181 52.948 514.637 53.204C515.101 53.46 515.457 53.824 515.705 54.296C515.961 54.76 516.089 55.316 516.089 55.964C516.089 56.612 515.961 57.172 515.705 57.644C515.457 58.116 515.101 58.48 514.637 58.736C514.181 58.992 513.641 59.12 513.017 59.12ZM513.017 57.968C513.489 57.968 513.865 57.804 514.145 57.476C514.425 57.14 514.565 56.636 514.565 55.964C514.565 55.292 514.425 54.792 514.145 54.464C513.865 54.136 513.489 53.972 513.017 53.972C512.545 53.972 512.169 54.136 511.889 54.464C511.609 54.792 511.469 55.292 511.469 55.964C511.469 56.636 511.609 57.14 511.889 57.476C512.169 57.804 512.545 57.968 513.017 57.968ZM517.382 59V54.452C517.382 54.204 517.374 53.952 517.358 53.696C517.342 53.44 517.318 53.188 517.286 52.94H518.738L518.858 54.14H518.714C518.906 53.716 519.19 53.392 519.566 53.168C519.942 52.936 520.378 52.82 520.874 52.82C521.586 52.82 522.122 53.02 522.482 53.42C522.842 53.82 523.022 54.444 523.022 55.292V59H521.522V55.364C521.522 54.876 521.426 54.528 521.234 54.32C521.05 54.104 520.77 53.996 520.394 53.996C519.93 53.996 519.562 54.14 519.29 54.428C519.018 54.716 518.882 55.1 518.882 55.58V59H517.382ZM527.205 59.12C526.485 59.12 525.941 58.932 525.573 58.556C525.205 58.18 525.021 57.616 525.021 56.864V54.068H523.857V52.94H525.021V51.392L526.521 51.008V52.94H528.141V54.068H526.521V56.768C526.521 57.184 526.601 57.476 526.761 57.644C526.921 57.812 527.141 57.896 527.421 57.896C527.573 57.896 527.701 57.884 527.805 57.86C527.917 57.836 528.025 57.804 528.129 57.764V58.952C527.993 59.008 527.841 59.048 527.673 59.072C527.513 59.104 527.357 59.12 527.205 59.12ZM532.573 59V50.54H538.153V51.752H534.121V54.152H537.877V55.364H534.121V59H532.573ZM539.32 59V52.94H540.82V59H539.32ZM539.236 51.8V50.336H540.904V51.8H539.236ZM542.449 59V50.168H543.949V59H542.449ZM545.578 59V50.168H547.078V59H545.578ZM550.867 59.12C550.347 59.12 549.867 59.06 549.427 58.94C548.995 58.812 548.631 58.636 548.335 58.412L548.755 57.404C549.059 57.612 549.395 57.772 549.763 57.884C550.131 57.996 550.503 58.052 550.879 58.052C551.279 58.052 551.575 57.984 551.767 57.848C551.967 57.712 552.067 57.528 552.067 57.296C552.067 57.112 552.003 56.968 551.875 56.864C551.755 56.752 551.559 56.668 551.287 56.612L550.087 56.384C549.575 56.272 549.183 56.08 548.911 55.808C548.647 55.536 548.515 55.18 548.515 54.74C548.515 54.364 548.615 54.032 548.815 53.744C549.023 53.456 549.315 53.232 549.691 53.072C550.075 52.904 550.523 52.82 551.035 52.82C551.483 52.82 551.903 52.88 552.295 53C552.695 53.12 553.031 53.3 553.303 53.54L552.871 54.512C552.623 54.312 552.339 54.156 552.019 54.044C551.699 53.932 551.387 53.876 551.083 53.876C550.667 53.876 550.363 53.952 550.171 54.104C549.979 54.248 549.883 54.436 549.883 54.668C549.883 54.844 549.939 54.992 550.051 55.112C550.171 55.224 550.355 55.308 550.603 55.364L551.803 55.592C552.339 55.696 552.743 55.88 553.015 56.144C553.295 56.4 553.435 56.752 553.435 57.2C553.435 57.6 553.327 57.944 553.111 58.232C552.895 58.52 552.595 58.74 552.211 58.892C551.827 59.044 551.379 59.12 550.867 59.12Z",
  fill: "#141941"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__label-main-system",
  className: "label-main-system",
  filter: "url(#speaker-distribution_svg__filter2_d_2851_19726)"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__tip"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Polygon 4_3",
  d: "M172 91L180 86L180 91L180 96L172 91Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__text_3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 180,
  y: 79,
  width: 90,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Tooltip_3",
  d: "M189.257 96V87.54H190.613L193.721 94.536H193.349L196.457 87.54H197.801V96H196.397V89.724H196.829L193.985 96H193.061L190.217 89.724H190.661V96H189.257ZM201.906 96.12C201.378 96.12 200.914 95.996 200.514 95.748C200.114 95.492 199.802 95.128 199.578 94.656C199.354 94.184 199.242 93.62 199.242 92.964C199.242 92.308 199.354 91.748 199.578 91.284C199.802 90.812 200.114 90.452 200.514 90.204C200.914 89.948 201.378 89.82 201.906 89.82C202.418 89.82 202.866 89.948 203.25 90.204C203.642 90.452 203.902 90.788 204.03 91.212H203.898L204.03 89.94H205.47C205.446 90.188 205.422 90.44 205.398 90.696C205.382 90.952 205.374 91.204 205.374 91.452V96H203.886L203.874 94.752H204.018C203.89 95.168 203.63 95.5 203.238 95.748C202.846 95.996 202.402 96.12 201.906 96.12ZM202.326 94.968C202.798 94.968 203.178 94.804 203.466 94.476C203.754 94.14 203.898 93.636 203.898 92.964C203.898 92.292 203.754 91.792 203.466 91.464C203.178 91.136 202.798 90.972 202.326 90.972C201.854 90.972 201.474 91.136 201.186 91.464C200.898 91.792 200.754 92.292 200.754 92.964C200.754 93.636 200.894 94.14 201.174 94.476C201.462 94.804 201.846 94.968 202.326 94.968ZM207.007 96V89.94H208.507V96H207.007ZM206.923 88.8V87.336H208.591V88.8H206.923ZM210.136 96V91.452C210.136 91.204 210.128 90.952 210.112 90.696C210.096 90.44 210.072 90.188 210.04 89.94H211.492L211.612 91.14H211.468C211.66 90.716 211.944 90.392 212.32 90.168C212.696 89.936 213.132 89.82 213.628 89.82C214.34 89.82 214.876 90.02 215.236 90.42C215.596 90.82 215.776 91.444 215.776 92.292V96H214.276V92.364C214.276 91.876 214.18 91.528 213.988 91.32C213.804 91.104 213.524 90.996 213.148 90.996C212.684 90.996 212.316 91.14 212.044 91.428C211.772 91.716 211.636 92.1 211.636 92.58V96H210.136ZM223.732 96.12C223.052 96.12 222.424 96.036 221.848 95.868C221.28 95.692 220.792 95.452 220.384 95.148L220.864 93.936C221.136 94.128 221.42 94.292 221.716 94.428C222.012 94.556 222.328 94.656 222.664 94.728C223 94.792 223.356 94.824 223.732 94.824C224.364 94.824 224.82 94.72 225.1 94.512C225.38 94.304 225.52 94.032 225.52 93.696C225.52 93.4 225.424 93.176 225.232 93.024C225.04 92.864 224.696 92.732 224.2 92.628L222.844 92.352C222.068 92.192 221.488 91.924 221.104 91.548C220.72 91.172 220.528 90.668 220.528 90.036C220.528 89.508 220.668 89.048 220.948 88.656C221.228 88.264 221.62 87.96 222.124 87.744C222.628 87.528 223.216 87.42 223.888 87.42C224.488 87.42 225.044 87.508 225.556 87.684C226.068 87.852 226.496 88.096 226.84 88.416L226.36 89.568C226.016 89.28 225.64 89.068 225.232 88.932C224.824 88.788 224.368 88.716 223.864 88.716C223.296 88.716 222.852 88.828 222.532 89.052C222.22 89.268 222.064 89.568 222.064 89.952C222.064 90.248 222.16 90.484 222.352 90.66C222.552 90.836 222.888 90.972 223.36 91.068L224.704 91.332C225.504 91.492 226.096 91.756 226.48 92.124C226.864 92.484 227.056 92.972 227.056 93.588C227.056 94.092 226.92 94.536 226.648 94.92C226.376 95.296 225.992 95.592 225.496 95.808C225 96.016 224.412 96.12 223.732 96.12ZM228.18 98.724L227.832 97.536C228.208 97.456 228.524 97.364 228.78 97.26C229.036 97.156 229.248 97.02 229.416 96.852C229.584 96.684 229.724 96.468 229.836 96.204L230.136 95.496L230.1 96.084L227.46 89.94H229.056L230.952 94.668H230.604L232.512 89.94H234.024L231.264 96.336C231.08 96.768 230.88 97.124 230.664 97.404C230.448 97.692 230.216 97.92 229.968 98.088C229.72 98.264 229.448 98.4 229.152 98.496C228.856 98.592 228.532 98.668 228.18 98.724ZM236.859 96.12C236.339 96.12 235.859 96.06 235.419 95.94C234.987 95.812 234.623 95.636 234.327 95.412L234.747 94.404C235.051 94.612 235.387 94.772 235.755 94.884C236.123 94.996 236.495 95.052 236.871 95.052C237.271 95.052 237.567 94.984 237.759 94.848C237.959 94.712 238.059 94.528 238.059 94.296C238.059 94.112 237.995 93.968 237.867 93.864C237.747 93.752 237.551 93.668 237.279 93.612L236.079 93.384C235.567 93.272 235.175 93.08 234.903 92.808C234.639 92.536 234.507 92.18 234.507 91.74C234.507 91.364 234.607 91.032 234.807 90.744C235.015 90.456 235.307 90.232 235.683 90.072C236.067 89.904 236.515 89.82 237.027 89.82C237.475 89.82 237.895 89.88 238.287 90C238.687 90.12 239.023 90.3 239.295 90.54L238.863 91.512C238.615 91.312 238.331 91.156 238.011 91.044C237.691 90.932 237.379 90.876 237.075 90.876C236.659 90.876 236.355 90.952 236.163 91.104C235.971 91.248 235.875 91.436 235.875 91.668C235.875 91.844 235.931 91.992 236.043 92.112C236.163 92.224 236.347 92.308 236.595 92.364L237.795 92.592C238.331 92.696 238.735 92.88 239.007 93.144C239.287 93.4 239.427 93.752 239.427 94.2C239.427 94.6 239.319 94.944 239.103 95.232C238.887 95.52 238.587 95.74 238.203 95.892C237.819 96.044 237.371 96.12 236.859 96.12ZM243.244 96.12C242.524 96.12 241.98 95.932 241.612 95.556C241.244 95.18 241.06 94.616 241.06 93.864V91.068H239.896V89.94H241.06V88.392L242.56 88.008V89.94H244.18V91.068H242.56V93.768C242.56 94.184 242.64 94.476 242.8 94.644C242.96 94.812 243.18 94.896 243.46 94.896C243.612 94.896 243.74 94.884 243.844 94.86C243.956 94.836 244.064 94.804 244.168 94.764V95.952C244.032 96.008 243.88 96.048 243.712 96.072C243.552 96.104 243.396 96.12 243.244 96.12ZM248.068 96.12C247.052 96.12 246.256 95.84 245.68 95.28C245.104 94.72 244.816 93.952 244.816 92.976C244.816 92.344 244.94 91.792 245.188 91.32C245.436 90.848 245.78 90.48 246.22 90.216C246.668 89.952 247.188 89.82 247.78 89.82C248.364 89.82 248.852 89.944 249.244 90.192C249.636 90.44 249.932 90.788 250.132 91.236C250.34 91.684 250.444 92.208 250.444 92.808V93.204H246.028V92.412H249.376L249.172 92.58C249.172 92.02 249.052 91.592 248.812 91.296C248.58 91 248.24 90.852 247.792 90.852C247.296 90.852 246.912 91.028 246.64 91.38C246.376 91.732 246.244 92.224 246.244 92.856V93.012C246.244 93.668 246.404 94.16 246.724 94.488C247.052 94.808 247.512 94.968 248.104 94.968C248.448 94.968 248.768 94.924 249.064 94.836C249.368 94.74 249.656 94.588 249.928 94.38L250.372 95.388C250.084 95.62 249.74 95.8 249.34 95.928C248.94 96.056 248.516 96.12 248.068 96.12ZM251.714 96V91.452C251.714 91.204 251.706 90.952 251.69 90.696C251.674 90.44 251.65 90.188 251.618 89.94H253.07L253.19 91.14H253.046C253.214 90.724 253.47 90.4 253.814 90.168C254.166 89.936 254.582 89.82 255.062 89.82C255.542 89.82 255.938 89.936 256.25 90.168C256.57 90.392 256.794 90.744 256.922 91.224H256.73C256.898 90.792 257.174 90.452 257.558 90.204C257.942 89.948 258.382 89.82 258.878 89.82C259.558 89.82 260.066 90.02 260.402 90.42C260.738 90.82 260.906 91.444 260.906 92.292V96H259.406V92.352C259.406 91.872 259.326 91.528 259.166 91.32C259.006 91.104 258.75 90.996 258.398 90.996C257.982 90.996 257.654 91.144 257.414 91.44C257.174 91.728 257.054 92.12 257.054 92.616V96H255.554V92.352C255.554 91.872 255.474 91.528 255.314 91.32C255.154 91.104 254.898 90.996 254.546 90.996C254.13 90.996 253.802 91.144 253.562 91.44C253.33 91.728 253.214 92.12 253.214 92.616V96H251.714Z",
  fill: "#141941"
}))), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__label-celling-system",
  className: "label-celling-system",
  filter: "url(#speaker-distribution_svg__filter3_d_2851_19726)"
}, /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__text_4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 333,
  y: 248,
  width: 100,
  height: 24,
  rx: 2,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Tooltip_4",
  d: "M346.077 265.12C345.197 265.12 344.441 264.944 343.809 264.592C343.185 264.232 342.705 263.728 342.369 263.08C342.033 262.424 341.865 261.652 341.865 260.764C341.865 259.876 342.033 259.108 342.369 258.46C342.705 257.812 343.185 257.312 343.809 256.96C344.441 256.6 345.197 256.42 346.077 256.42C346.669 256.42 347.201 256.504 347.673 256.672C348.153 256.84 348.565 257.088 348.909 257.416L348.405 258.64C348.029 258.336 347.665 258.12 347.313 257.992C346.969 257.856 346.573 257.788 346.125 257.788C345.269 257.788 344.613 258.048 344.157 258.568C343.709 259.08 343.485 259.812 343.485 260.764C343.485 261.716 343.709 262.452 344.157 262.972C344.613 263.492 345.269 263.752 346.125 263.752C346.573 263.752 346.969 263.688 347.313 263.56C347.665 263.424 348.029 263.2 348.405 262.888L348.909 264.112C348.565 264.432 348.153 264.68 347.673 264.856C347.201 265.032 346.669 265.12 346.077 265.12ZM352.742 265.12C351.726 265.12 350.93 264.84 350.354 264.28C349.778 263.72 349.49 262.952 349.49 261.976C349.49 261.344 349.614 260.792 349.862 260.32C350.11 259.848 350.454 259.48 350.894 259.216C351.342 258.952 351.862 258.82 352.454 258.82C353.038 258.82 353.526 258.944 353.918 259.192C354.31 259.44 354.606 259.788 354.806 260.236C355.014 260.684 355.118 261.208 355.118 261.808V262.204H350.702V261.412H354.05L353.846 261.58C353.846 261.02 353.726 260.592 353.486 260.296C353.254 260 352.914 259.852 352.466 259.852C351.97 259.852 351.586 260.028 351.314 260.38C351.05 260.732 350.918 261.224 350.918 261.856V262.012C350.918 262.668 351.078 263.16 351.398 263.488C351.726 263.808 352.186 263.968 352.778 263.968C353.122 263.968 353.442 263.924 353.738 263.836C354.042 263.74 354.33 263.588 354.602 263.38L355.046 264.388C354.758 264.62 354.414 264.8 354.014 264.928C353.614 265.056 353.19 265.12 352.742 265.12ZM356.388 265V258.94H357.888V265H356.388ZM356.304 257.8V256.336H357.972V257.8H356.304ZM359.517 265V256.168H361.017V265H359.517ZM362.646 265V258.94H364.146V265H362.646ZM362.562 257.8V256.336H364.23V257.8H362.562ZM365.775 265V260.452C365.775 260.204 365.767 259.952 365.751 259.696C365.735 259.44 365.711 259.188 365.679 258.94H367.131L367.251 260.14H367.107C367.299 259.716 367.583 259.392 367.959 259.168C368.335 258.936 368.771 258.82 369.267 258.82C369.979 258.82 370.515 259.02 370.875 259.42C371.235 259.82 371.415 260.444 371.415 261.292V265H369.915V261.364C369.915 260.876 369.819 260.528 369.627 260.32C369.443 260.104 369.163 259.996 368.787 259.996C368.323 259.996 367.955 260.14 367.683 260.428C367.411 260.716 367.275 261.1 367.275 261.58V265H365.775ZM375.813 267.688C375.253 267.688 374.745 267.628 374.289 267.508C373.841 267.388 373.441 267.204 373.089 266.956L373.413 265.876C373.645 266.028 373.885 266.152 374.133 266.248C374.381 266.344 374.637 266.416 374.901 266.464C375.165 266.512 375.433 266.536 375.705 266.536C376.265 266.536 376.681 266.396 376.953 266.116C377.233 265.844 377.373 265.452 377.373 264.94V263.488H377.493C377.365 263.904 377.105 264.236 376.713 264.484C376.329 264.732 375.885 264.856 375.381 264.856C374.837 264.856 374.361 264.736 373.953 264.496C373.553 264.248 373.241 263.896 373.017 263.44C372.793 262.984 372.681 262.448 372.681 261.832C372.681 261.216 372.793 260.684 373.017 260.236C373.241 259.78 373.553 259.432 373.953 259.192C374.361 258.944 374.837 258.82 375.381 258.82C375.893 258.82 376.337 258.944 376.713 259.192C377.097 259.432 377.353 259.76 377.481 260.176L377.373 260.104L377.493 258.94H378.945C378.913 259.188 378.889 259.44 378.873 259.696C378.857 259.952 378.849 260.204 378.849 260.452V264.76C378.849 265.712 378.589 266.436 378.069 266.932C377.557 267.436 376.805 267.688 375.813 267.688ZM375.789 263.704C376.269 263.704 376.649 263.544 376.929 263.224C377.217 262.896 377.361 262.432 377.361 261.832C377.361 261.232 377.217 260.772 376.929 260.452C376.649 260.132 376.269 259.972 375.789 259.972C375.301 259.972 374.913 260.132 374.625 260.452C374.337 260.772 374.193 261.232 374.193 261.832C374.193 262.432 374.337 262.896 374.625 263.224C374.913 263.544 375.301 263.704 375.789 263.704ZM386.835 265.12C386.155 265.12 385.527 265.036 384.951 264.868C384.383 264.692 383.895 264.452 383.487 264.148L383.967 262.936C384.239 263.128 384.523 263.292 384.819 263.428C385.115 263.556 385.431 263.656 385.767 263.728C386.103 263.792 386.459 263.824 386.835 263.824C387.467 263.824 387.923 263.72 388.203 263.512C388.483 263.304 388.623 263.032 388.623 262.696C388.623 262.4 388.527 262.176 388.335 262.024C388.143 261.864 387.799 261.732 387.303 261.628L385.947 261.352C385.171 261.192 384.591 260.924 384.207 260.548C383.823 260.172 383.631 259.668 383.631 259.036C383.631 258.508 383.771 258.048 384.051 257.656C384.331 257.264 384.723 256.96 385.227 256.744C385.731 256.528 386.319 256.42 386.991 256.42C387.591 256.42 388.147 256.508 388.659 256.684C389.171 256.852 389.599 257.096 389.943 257.416L389.463 258.568C389.119 258.28 388.743 258.068 388.335 257.932C387.927 257.788 387.471 257.716 386.967 257.716C386.399 257.716 385.955 257.828 385.635 258.052C385.323 258.268 385.167 258.568 385.167 258.952C385.167 259.248 385.263 259.484 385.455 259.66C385.655 259.836 385.991 259.972 386.463 260.068L387.807 260.332C388.607 260.492 389.199 260.756 389.583 261.124C389.967 261.484 390.159 261.972 390.159 262.588C390.159 263.092 390.023 263.536 389.751 263.92C389.479 264.296 389.095 264.592 388.599 264.808C388.103 265.016 387.515 265.12 386.835 265.12ZM391.284 267.724L390.936 266.536C391.312 266.456 391.628 266.364 391.884 266.26C392.14 266.156 392.352 266.02 392.52 265.852C392.688 265.684 392.828 265.468 392.94 265.204L393.24 264.496L393.204 265.084L390.564 258.94H392.16L394.056 263.668H393.708L395.616 258.94H397.128L394.368 265.336C394.184 265.768 393.984 266.124 393.768 266.404C393.552 266.692 393.32 266.92 393.072 267.088C392.824 267.264 392.552 267.4 392.256 267.496C391.96 267.592 391.636 267.668 391.284 267.724ZM399.962 265.12C399.442 265.12 398.962 265.06 398.522 264.94C398.09 264.812 397.726 264.636 397.43 264.412L397.85 263.404C398.154 263.612 398.49 263.772 398.858 263.884C399.226 263.996 399.598 264.052 399.974 264.052C400.374 264.052 400.67 263.984 400.862 263.848C401.062 263.712 401.162 263.528 401.162 263.296C401.162 263.112 401.098 262.968 400.97 262.864C400.85 262.752 400.654 262.668 400.382 262.612L399.182 262.384C398.67 262.272 398.278 262.08 398.006 261.808C397.742 261.536 397.61 261.18 397.61 260.74C397.61 260.364 397.71 260.032 397.91 259.744C398.118 259.456 398.41 259.232 398.786 259.072C399.17 258.904 399.618 258.82 400.13 258.82C400.578 258.82 400.998 258.88 401.39 259C401.79 259.12 402.126 259.3 402.398 259.54L401.966 260.512C401.718 260.312 401.434 260.156 401.114 260.044C400.794 259.932 400.482 259.876 400.178 259.876C399.762 259.876 399.458 259.952 399.266 260.104C399.074 260.248 398.978 260.436 398.978 260.668C398.978 260.844 399.034 260.992 399.146 261.112C399.266 261.224 399.45 261.308 399.698 261.364L400.898 261.592C401.434 261.696 401.838 261.88 402.11 262.144C402.39 262.4 402.53 262.752 402.53 263.2C402.53 263.6 402.422 263.944 402.206 264.232C401.99 264.52 401.69 264.74 401.306 264.892C400.922 265.044 400.474 265.12 399.962 265.12ZM406.347 265.12C405.627 265.12 405.083 264.932 404.715 264.556C404.347 264.18 404.163 263.616 404.163 262.864V260.068H402.999V258.94H404.163V257.392L405.663 257.008V258.94H407.283V260.068H405.663V262.768C405.663 263.184 405.743 263.476 405.903 263.644C406.063 263.812 406.283 263.896 406.563 263.896C406.715 263.896 406.843 263.884 406.947 263.86C407.059 263.836 407.167 263.804 407.271 263.764V264.952C407.135 265.008 406.983 265.048 406.815 265.072C406.655 265.104 406.499 265.12 406.347 265.12ZM411.172 265.12C410.156 265.12 409.36 264.84 408.784 264.28C408.208 263.72 407.92 262.952 407.92 261.976C407.92 261.344 408.044 260.792 408.292 260.32C408.54 259.848 408.884 259.48 409.324 259.216C409.772 258.952 410.292 258.82 410.884 258.82C411.468 258.82 411.956 258.944 412.348 259.192C412.74 259.44 413.036 259.788 413.236 260.236C413.444 260.684 413.548 261.208 413.548 261.808V262.204H409.132V261.412H412.48L412.276 261.58C412.276 261.02 412.156 260.592 411.916 260.296C411.684 260 411.344 259.852 410.896 259.852C410.4 259.852 410.016 260.028 409.744 260.38C409.48 260.732 409.348 261.224 409.348 261.856V262.012C409.348 262.668 409.508 263.16 409.828 263.488C410.156 263.808 410.616 263.968 411.208 263.968C411.552 263.968 411.872 263.924 412.168 263.836C412.472 263.74 412.76 263.588 413.032 263.38L413.476 264.388C413.188 264.62 412.844 264.8 412.444 264.928C412.044 265.056 411.62 265.12 411.172 265.12ZM414.818 265V260.452C414.818 260.204 414.81 259.952 414.794 259.696C414.778 259.44 414.754 259.188 414.722 258.94H416.174L416.294 260.14H416.15C416.318 259.724 416.574 259.4 416.918 259.168C417.27 258.936 417.686 258.82 418.166 258.82C418.646 258.82 419.042 258.936 419.354 259.168C419.674 259.392 419.898 259.744 420.026 260.224H419.834C420.002 259.792 420.278 259.452 420.662 259.204C421.046 258.948 421.486 258.82 421.982 258.82C422.662 258.82 423.17 259.02 423.506 259.42C423.842 259.82 424.01 260.444 424.01 261.292V265H422.51V261.352C422.51 260.872 422.43 260.528 422.27 260.32C422.11 260.104 421.854 259.996 421.502 259.996C421.086 259.996 420.758 260.144 420.518 260.44C420.278 260.728 420.158 261.12 420.158 261.616V265H418.658V261.352C418.658 260.872 418.578 260.528 418.418 260.32C418.258 260.104 418.002 259.996 417.65 259.996C417.234 259.996 416.906 260.144 416.666 260.44C416.434 260.728 416.318 261.12 416.318 261.616V265H414.818Z",
  fill: "#141941"
})), /*#__PURE__*/React.createElement("g", {
  id: "speaker-distribution_svg__tip_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "speaker-distribution_svg__Polygon 4_4",
  d: "M383 280L378 272L383 272L388 272L383 280Z",
  fill: "white"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "speaker-distribution_svg__filter0_d_2851_19726",
  x: 327,
  y: 22,
  width: 57,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2851_19726"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2851_19726",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "speaker-distribution_svg__filter1_d_2851_19726",
  x: 480,
  y: 29,
  width: 92,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2851_19726"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2851_19726",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "speaker-distribution_svg__filter2_d_2851_19726",
  x: 162,
  y: 74,
  width: 118,
  height: 44,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2851_19726"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2851_19726",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "speaker-distribution_svg__filter3_d_2851_19726",
  x: 323,
  y: 243,
  width: 120,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2851_19726"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2851_19726",
  result: "shape"
})))));
export default SvgSpeakerDistribution;